if (!customElements.get('component-cart-body')) {
  customElements.define('component-cart-body', class CartBody extends HTMLElement {
    constructor() {
      super();

      this.state = {
        firstGift: null,
        secondGift: null,
        thirdGift: null
      }

      this.minusButton = this.querySelector('.js-cart-item-button-minus');
      this.emptyCart = this.querySelector('.js-empty-cart');
      this.itemsBlock = this.querySelector('.js-items-block');
      this.emptyButton = this.querySelector('.js-empty-button');
      this.clearCartButton = this.querySelector('.js-clear-cart-button');
      this.applyDiscountCodeBtn = this.querySelector('.js-component-cart-body-discount-code-button');
      this.discountCodeSection = this.querySelector('.js-component-cart-body-discount-code');
      this.checkoutButton = document.querySelector('.js-checkout-button');
      this.perfectPromiseDescription = this.querySelector('.js-component-cart-body-text-block-description');

      this.settings = {
        countryCode: window.Shopify.country,
        oosItemKey: this.dataset.oosItemKey,
        showClearCartButton: this.dataset.showClearCartButton === 'true',
        outOfStockThreshold: +this.dataset.outOfStockThreshold || 0,
        openOnItemAdded: this.dataset.openOnItemAdded === 'true',
        finalSaleLabel: this.dataset.finalSaleLabel || 'Final Sale',
        emptyCartButtonUrl: this.dataset.emptyCartButtonUrl || `https://${window.Shopify.shop}${window.Shopify.routes.root}collections/bras`,
        hideFooterOnEmptyCart: this.dataset.hideFooterOnEmptyCart === 'true',
        fsThreshold: +this.dataset.fsThreshold,
        gwpEnabled: this.dataset.gwpEnabled === 'true',
        gwpMultipleGiftEnabled: this.dataset.gwpMultipleGiftEnabled === 'true',
        gwpOnlyOneGiftEnabled: this.dataset.gwpOnlyOneGiftEnabled === 'true',
        gwpPosition: this.dataset.gwpPosition || 'top',
        gwpFirstGift: this.dataset.gwpFirstGift,
        gwpFirstGiftVariant: +this.dataset.gwpFirstGiftVariant,
        gwpFirstThreshold: +this.dataset.gwpFirstThreshold || 0,
        gwpFirstBoxTitle: this.dataset.gwpFirstBoxTitle || 'Free Gift',
        gwpOutOfStockFirstThreshold: +this.dataset.gwpOutOfStockFirstThreshold || 0,
        gwpFirstTrueSize: this.dataset.gwpFirstTrueSize === 'true',
        gwpSecondGift: this.dataset.gwpSecondGift,
        gwpSecondGiftVariant: +this.dataset.gwpSecondGiftVariant,
        gwpSecondThreshold: +this.dataset.gwpSecondThreshold || 0,
        gwpSecondBoxTitle: this.dataset.gwpSecondBoxTitle || 'Free Gift',
        gwpOutOfStockSecondThreshold: +this.dataset.gwpOutOfStockSecondThreshold || 0,
        gwpSecondTrueSize: this.dataset.gwpSecondTrueSize === 'true',
        gwpThirdGift: this.dataset.gwpThirdGift,
        gwpThirdGiftVariant: +this.dataset.gwpThirdGiftVariant,
        gwpThirdThreshold: +this.dataset.gwpThirdThreshold || 0,
        gwpThirdBoxTitle: this.dataset.gwpThirdBoxTitle || 'Free Gift',
        gwpOutOfStockThirdThreshold: +this.dataset.gwpOutOfStockThirdThreshold || 0,
        gwpThirdTrueSize: this.dataset.gwpThirdTrueSize === 'true',
        gwpThresholdUseTotal: this.dataset.gwpThresholdUseTotal === 'true',
        gwpIncludeTag: this.dataset.gwpIncludeTag,
        gwpExcludeTag: this.dataset.gwpExcludeTag,
        gwpExcludeProductTypeList: this.dataset.gwpExcludeProductTypeList,
        gwpFreeLabel: this.dataset.gwpFreeLabel,
        gwpLinkEnabled: this.dataset.gwpLinkEnabled === 'true',
        upsEnabled: this.dataset.upsEnabled === 'true',
        upsRecIntent: this.dataset.upsRecIntent,
        upsTrueSizeEnabled: this.dataset.upsTrueSizeEnabled === 'true',
        upsOnlyTrueSizeEnabled: this.dataset.upsOnlyTrueSizeEnabled === 'true',
        upsOnlyTrueSizeEnabledExceptionTags: this.dataset.upsOnlyTrueSizeEnabledExceptionTags?.split(',').map(tag => tag.trim()) || [],
        upsSizeSelectorEnabled: this.dataset.upsSizeSelectorEnabled === 'true',
        upsNoTrueSizeShowProducts: this.dataset.upsNoTrueSizeShowProducts === 'true',
        upsEmptyCartEnabled: this.dataset.upsEmptyCartEnabled === 'true',
        upsEmptyCartRecIntent: this.dataset.upsEmptyCartRecIntent,
        upsEmptyCartProductId: this.dataset.upsEmptyCartProductId,
        upsEmptyCartTrueSizeEnabled: this.dataset.upsEmptyCartTrueSizeEnabled === 'true',
        upsEmptyCartOnlyTrueSizeEnabled: this.dataset.upsEmptyCartOnlyTrueSizeEnabled === 'true',
        upsEmptyCartOnlyTrueSizeEnabledExceptionTags: this.dataset.upsEmptyCartOnlyTrueSizeEnabledExceptionTags?.split(',').map(tag => tag.trim()) || [],
        upsEmptyCartSizeSelectorEnabled: this.dataset.upsEmptyCartSizeSelectorEnabled === 'true',
        upsEmptyCartNoTrueSizeShowProducts: this.dataset.upsEmptyCartNoTrueSizeShowProducts === 'true',
        upsPosition: this.dataset.upsPosition || 'bottom',
        upsTitle: this.dataset.upsTitle,
        upsEmptyCartTitle: this.dataset.upsEmptyCartTitle,
        upsNumOfProd: +this.dataset.upsNumOfProd || 10,
        upsEmptyCartNumOfProd: +this.dataset.upsEmptyCartNumOfProd || 10,
        upsShowAddToCartButton: this.dataset.upsShowAddToCartButton === 'true',
        upsEmptyCartShowAddToCartButton: this.dataset.upsEmptyCartShowAddToCartButton === 'true',
        upsAddToCartButtonLabel: this.dataset.upsAddToCartButtonLabel || 'Add to bag',
        upsEmptyCartAddToCartButtonLabel: this.dataset.upsEmptyCartAddToCartButtonLabel || 'Add to bag',
        upsShowFixedProducts: this.dataset.upsShowFixedProducts === 'true',
        upsEmptyCartShowFixedProducts: this.dataset.upsEmptyCartShowFixedProducts === 'true',
        upsFixedProducts: this.dataset.upsFixedProducts.replace(' ','').split(',').filter(item => !!item),
        upsFixedProductsCacheTime: +this.dataset.upsFixedProductsCacheTime || 0,
        upsEmptyCartFixedProducts: this.dataset.upsEmptyCartFixedProducts.replace(' ','').split(',').filter(item => !!item),
        upsEmptyCartFixedProductsCacheTime: +this.dataset.upsEmptyCartFixedProductsCacheTime || 0,
        upsRebuyEnabled: this.dataset.upsRebuyEnabled === 'true',
        upsRebuyTitle: this.dataset.upsRebuyTitle,
        upsRebuyButtonLabel: this.dataset.upsRebuyButtonLabel,
        upsRebuyType: this.dataset.upsRebuyType,
        upsRebuyApiKey: this.dataset.upsRebuyApiKey,
        upsRebuyProductsApiUrl: this.dataset.upsRebuyProductsApiUrl,
        upsRebuyEventApiUrl: this.dataset.upsRebuyEventApiUrl,
        upsRebuyApiLimit: this.dataset.upsRebuyApiLimit,
        showBundleCompareAtPrice: this.dataset.showBundleCompareAtPrice === 'true',
        bbPdpEnabled: this.dataset.bbPdpEnabled === 'true',
        dkBBPdpEnabled: this.dataset.dkBbPdpEnabled === 'true',
        dkBBMiniCartLabelTemplate: this.dataset.dkBbMiniCartLabelTemplate,
        dkBBMiniCartLabelTemplatePercent: this.dataset.dkBbMiniCartLabelTemplatePercent || '',
        dkBBMiniCartLabelTemplatePercentBetweenTiers: this.dataset.dkBbMiniCartLabelTemplatePercentBetweenTiers || '',
        dkBBMiniCartLabelTemplatePercentOneAway: this.dataset.dkBbMiniCartLabelTemplatePercentOneAway || '',
        dkBBMiniCartLabelTemplatePercentMaxTier: this.dataset.dkBbMiniCartLabelTemplatePercentMaxTier || '',
        bbAutoEnabled: this.dataset.bbAutoEnabled === 'true',
        abEnabled: this.dataset.abEnabled === 'true',
        abTitle: this.dataset.abTitle || '',
        abShowAmountOfProductsInTitle: this.dataset.abShowAmountOfProductsInTitle === 'true',
        abRepeatProductTypeEnabled: this.dataset.abRepeatProductTypeEnabled === 'true',
        abRepeatProductColorEnabled: this.dataset.abRepeatProductColorEnabled === 'true',
        abRepeatProductVariantEnabled: this.dataset.abRepeatProductVariantEnabled === 'true',
        abLimit: +this.dataset.abLimit || 100,
        bdEnabled: this.dataset.bdEnabled === 'true',
        bdTag: this.dataset.bdTag,
        bdProductType: this.dataset.bdProductType,
        bdPromoExcludeLabel: this.dataset.bdPromoExcludeLabel,
        bdSaleItemExcludeLabel: this.dataset.bdSaleItemExcludeLabel,
        bdSellingPlanExcludeLabel: this.dataset.bdSellingPlanExcludeLabel,
        bdGwpExcludeLabel: this.dataset.bdGwpExcludeLabel,
        bdGiftCardExcludeLabel: this.dataset.bdGiftCardExcludeLabel,
        sgdEnabled: this.dataset.sgdEnabled === 'true',
        sgdExcludeThresholdTagName: this.dataset.sgdExcludeThresholdTagName,
        sgdTagExcludeLabel: this.dataset.sgdTagExcludeLabel,
        sgdSaleItemExcludeLabel: this.dataset.sgdSaleItemExcludeLabel,
        sgdSellingPlanExcludeLabel: this.dataset.sgdSellingPlanExcludeLabel,
        sgdGwpExcludeLabel: this.dataset.sgdGwpExcludeLabel,
        sgdAbExcludeLabel: this.dataset.sgdAbExcludeLabel,
        dcErrorMissing: this.dataset.dcErrorMissing || 'Please enter a discount code',
        dcErrorInvalid: this.dataset.dcErrorInvalid || 'Invalid discount code',
        dcErrorNotExist: this.dataset.dcErrorNotExist || 'Discount code does not exist',
        dcErrorRepeated: this.dataset.dcErrorRepeated || 'Discount code already applied',
        dcErrorNotApplicable: this.dataset.dcErrorNotApplicable || 'Discount code not applicable for the items in your cart',
        dcErrorNotApplicableWithExistingDiscounts: this.dataset.dcErrorNotApplicableWithExistingDiscounts || 'Discount code not applicable with existing discounts',
        dcErrorUnexpected: this.dataset.dcErrorUnexpected || 'An unexpected error occurred'
      }

      if (this.settings.abRepeatProductColorEnabled) {
        this.settings.abRepeatProductTypeEnabled = true;
      }

      if (this.settings.abRepeatProductVariantEnabled) {
        this.settings.abRepeatProductTypeEnabled = true;
        this.settings.abRepeatProductColorEnabled = true;
      }

      if (this.settings.upsEnabled || this.settings.gwpEnabled || this.settings.upsRebuyEnabled) {
        const cookieUnderwearSize = getUserFittingRoomUnderwearSize();
        const cookieBandSize = getUserFittingRoomBandSize();
        const cookieCupSize = getUserFittingRoomCupSize();
        if (cookieUnderwearSize || (cookieBandSize && cookieCupSize)) {
          this.settings.trueSize = {
            underwearSize: cookieUnderwearSize,
            braBand: cookieBandSize,
            braCup: cookieCupSize,
            braSize: (cookieBandSize && cookieCupSize) ? `${cookieBandSize}${cookieCupSize}` : null,
          };
        } else {
          this.settings.trueSize = null;
        }
      }

      if (this.settings.oosItemKey) {
        console.error('one or more items in the cart are sold out');
      }

      this.setEventListeners();

      if (this.settings.upsEmptyCartEnabled && this.itemsBlock.classList.contains('hidden')) {
        this.showUpsells(true);
      } else {
        this.style.justifyContent = 'flex-start';
      }

      this.render();

      if (this.settings.upsRebuyEnabled) {
        this.renderUpsellsRebuy();
      }

      if (this.perfectPromiseDescription) {
        this.perfectPromiseContent = this.perfectPromiseDescription.querySelector('p').innerText;
        this.renderPerfectFit();
      }

      this.initCartRecommFonts('.bloomreach-form-sidecart');
      this.initCartRecommFonts('.bloomreach-form-sidecart-recently');
      
    }

    async render() {
      const cart = await window.cartManager?.getLocalCartAsync();
      if (cart) {
        let renderCartItems = false;
        let response = null;

        if (!cart.items.length) {
          await window.cartManager.syncCartSettings();
          return;
        }

        // Remove bundles and gifts from cart when the features are off
        response = await window.cartManager.sanitize(this.settings);
        if (response?.status === 'updated') renderCartItems = true;

        // Update cart with current theme settings
        response = await window.cartManager.syncCartSettings();
        if (response?.status === 'updated') renderCartItems = true;

        // DISABLED (TLDEV-589) - see renderDiscountKitProperties below
        // Check if there are any products with discount kit tag and update the discount kit properties
        // this.renderDiscountKitProperties();

        // Check AB if it's enabled
        if (this.settings.abEnabled && window.cartManager.checkAutoBundle()) {
          this.autoBundling();
          return;
        }

        if (renderCartItems) {
          window.broadcastChannel.dispatchEvent('render-cart-items', {openCartDrawer: false});
          return;
        }

        if (this.settings.gwpEnabled) {
          const gwpExcludeProductTypeListArray = this.settings.gwpExcludeProductTypeList?.length ? this.settings.gwpExcludeProductTypeList.split(',').filter(item => !!item).map(item => item.toLocaleLowerCase()) : null;

          let cartTotalPrice = cart.items.reduce((cartTotal, item) => {
            const productType = item.product_type.toLowerCase();
            if (this.settings.gwpExcludeTag && item.properties._tags?.includes(this.settings.gwpExcludeTag)) {
              return cartTotal;
            } else if (gwpExcludeProductTypeListArray?.includes(productType)) {
              return cartTotal;
            } else if (item.properties._isGWP && !this.settings.gwpThresholdUseTotal) {
              return cartTotal;
            } else if (!this.settings.gwpIncludeTag || (this.settings.gwpIncludeTag && item.properties._tags?.includes(this.settings.gwpIncludeTag))) {
              return cartTotal + item.price * item.quantity;
            } else {
              return cartTotal;
            }
          }, 0);

          if (this.settings.gwpThresholdUseTotal) {
            cartTotalPrice -= cart.discount;
          }

          const updateCart = await this.updateGWP(cartTotalPrice);
          if (updateCart) {
            window.broadcastChannel.dispatchEvent('render-cart-items', {openCartDrawer: false});
            return;
          }

          // Render GWP Box
          await this.updateGWPBox(cartTotalPrice);
        }
        if (this.settings.upsEnabled && !this.itemsBlock.classList.contains('hidden')) {
          this.showUpsells(false);
        } else {
          this.style.justifyContent = 'flex-start';
        }
      }
    }

    initCartRecommFonts(target) {
      const targetNode = document.querySelector(target);
      const config = { attributes: true, childList: true, subtree: true };
      const callback = (mutationList, observer) => {
        for (const mutation of mutationList) {
          if (mutation.type === "childList") {
            const shadow = document.querySelector(`${target} > div`) ? document.querySelector(`${target} > div`).shadowRoot : null;
            if (shadow){
              const recom = shadow.querySelector('.weblayer--box-recommendation-sidecart');
              const recomButtons = shadow.querySelectorAll('.weblayer--box-recommendation-sidecart button:not(.nav-arrow)');
              const recomSels = shadow.querySelectorAll('.weblayer--box-recommendation-sidecart select');
              recom.style.fontFamily = 'Rules';
              recomButtons.forEach((el) => {
                el.style.fontFamily = 'Rules';
                el.style.fontSize = '10px';
                el.textContent = 'Add to Bag';
              })
              recomSels.forEach((el) => {
                el.style.fontFamily = 'Rules';
                el.style.fontSize = '12px';
              })
              const recomTitle = shadow.querySelector('.weblayer--box-recommendation-sidecart .best-sellers-title');
              const recomItemTitles = shadow.querySelectorAll('.weblayer--box-recommendation-sidecart .component-cart-body__ups__product-title');
              const recomItemPrices = shadow.querySelectorAll('.weblayer--box-recommendation-sidecart .component-cart-body__ups__product-price');
              recomTitle.style.fontSize = '20px';            
              recomItemTitles.forEach((el) => {
                el.style.fontSize = '12px';
              })
              recomItemPrices.forEach((el) => {
                el.style.fontSize = '14px';
              })
            }
          }
        }
      };
      const observer = new MutationObserver(callback);
      observer.observe(targetNode, config);
      // observer.disconnect();
    }

    setEventListeners() {
      this.emptyButton?.addEventListener('click', () => {
        this.redirectTo(this.settings.emptyCartButtonUrl);
      });

      this.clearCartButton?.addEventListener('click', async (event) => {
        event.preventDefault();
        event.stopPropagation();
        await window.cartManager.clearCart();
        window.broadcastChannel.dispatchEvent('render-cart-items', {openCartDrawer: false});
      });

      window.addEventListener('disable-cart-upsells', () => {
        const recProducts = this.recContainerEl?.querySelectorAll('.component-cart-body__ups__product') || [];
        const rebuyRecProducts = this.rebuyRecContainerEl?.querySelectorAll('.component-cart-body__ups__product') || [];
        const productsEls = [...recProducts, ...rebuyRecProducts];

        if (productsEls?.length) {
          productsEls.forEach(prod => {
            prod.querySelector('.js-recommendation-product-image-link')?.classList.add('disabled');
            prod.querySelector('.js-recommendation-product-title')?.classList.add('disabled');
            prod.querySelector('.js-recommendation-product-price')?.classList.add('disabled');
            if (prod.querySelector('.js-recommendation-product-size-select')) {
              prod.querySelector('.js-recommendation-product-size-select').disabled = true;
            }
            prod.querySelector('.js-recommendation-product-add-to-cart-button').disabled = true;
          });
        }
      });

      window.addEventListener('update-cart', async (data) => {
        // Create and update auto bundles if needed
        if (this.settings.abEnabled && window.cartManager.checkAutoBundle()) {
          await window.cartManager.autoBundling();
        }

        // DISABLED (TLDEV-589) - see renderDiscountKitProperties below
        // this.renderDiscountKitProperties();

        if (this.discountCodeSection) {
          if (window.cartManager.getLocalCart().items.length) {
            this.discountCodeSection.classList.remove('hidden');
          } else {
            this.discountCodeSection.classList.add('hidden');
          }
        }
        
        window.broadcastChannel.dispatchEvent('render-cart-items', data.detail);
      });

      window.addEventListener('render-cart-items', (data) => {
        this.renderCartItems(data.detail?.openCartDrawer);
      });

      window.addEventListener('render-cart-upsells', () => {
        const items = window.cartManager?.getLocalCart()?.items;
        if (!items?.length && this.settings.upsEmptyCartEnabled) {
          this.showUpsells(true);
          return;
        } else if (this.settings.upsEnabled && !this.itemsBlock.classList.contains('hidden')) {
          this.showUpsells(false);
        } else if (this.settings.upsEmptyCartEnabled && this.itemsBlock.classList.contains('hidden')) {
          this.showUpsells(true);
        } else {
          this.style.justifyContent = 'flex-start';
        }
      });

      window.addEventListener('render-cart-rebuy-upsells', () => {
        this.renderUpsellsRebuy();
      });

      if (this.applyDiscountCodeBtn) {
        window.addEventListener('refresh-discount-input', () => {
          const discountInputEl = this.querySelector('.js-cart-discount-code-input');
          const errorMessageEl = this.querySelector('.js-component-cart-body-discount-code-error');
          if (discountInputEl) {
            discountInputEl.value = '';
            discountInputEl.disabled = false;
          }
          if (errorMessageEl) errorMessageEl.textContent = '';
        });

        this.applyDiscountCodeBtn.addEventListener('click', async (e) => {
          e.preventDefault();
  
          const discountInputEl = this.querySelector('.js-cart-discount-code-input');
          const errorMessageEl = this.querySelector('.js-component-cart-body-discount-code-error');
          const loaderEl = this.querySelector('#js-component-cart-body-discount-code-button-loader');
          const buttonTextEl = this.querySelector('.js-component-cart-body-discount-code-button-text');
          const discountCode = discountInputEl.value.trim().toUpperCase();
  
          try {
            // Missing discount code error message
            if (!discountCode?.length) {
              throw 'DISCOUNT_CODE_MISSING';
            }
  
            // Invalid discount code error message
            if (discountCode.length < 3) {
              throw 'DISCOUNT_CODE_INVALID';
            }
  
            // Hide error message
            errorMessageEl.classList.add('invisible');
  
            // Get the cart
            const cart = await window.cartManager.getLocalCartAsync();

            // Repeated discount code error message
            if (cart.discount_codes?.length && cart.discount_codes.some(cartDiscountCode => cartDiscountCode.title.toUpperCase() === discountCode)) {
              throw 'DISCOUNT_CODE_REPEATED';
            }
  
            // Disable discount code input, apply button and checkout button
            discountInputEl.disabled = true;
            e.target.disabled = true;
            this.checkoutButton.disabled = true;
  
            // Show loader in button
            buttonTextEl.style.display = 'none';
            loaderEl.style.display = 'block';
  
            // Apply discount code
            await window.cartManager.applyDiscountCode(discountCode);
  
            // Update cart header banners, cart footer and cart items
            window.broadcastChannel.dispatchEvents(['update-cart-header-banners', 'update-cart-footer-prices', { name: 'render-cart-items', data: { openCartDrawer: false }}]);
  
            // Reset discount code input, apply button and checkout button
            discountInputEl.value = '';
            discountInputEl.disabled = false;
            e.target.disabled = false;
            this.checkoutButton.disabled = false;
  
            // Hide loader in button
            loaderEl.style.display = 'none';
            buttonTextEl.style.display = 'block';
          } catch(error) {  
            // Show error message
            const errorCode = error.code || error;
            if (errorCode === 'DISCOUNT_CODE_MISSING') {
              errorMessageEl.innerHTML = this.settings.dcErrorMissing;
            } else if (errorCode === 'DISCOUNT_CODE_INVALID') {
              errorMessageEl.innerHTML = this.settings.dcErrorInvalid;
            } else if (errorCode === 'DISCOUNT_CODE_REPEATED') {
              errorMessageEl.innerHTML = this.settings.dcErrorRepeated;
            } else if (errorCode === 'DISCOUNT_CODE_NOT_EXIST') {
              errorMessageEl.innerHTML = this.settings.dcErrorNotExist;
            } else if (errorCode === 'DISCOUNT_CODE_NOT_APPLICABLE') {
              errorMessageEl.innerHTML = this.settings.dcErrorNotApplicable;
            } else if (errorCode === 'DISCOUNT_CODE_NOT_APPLICABLE_WITH_EXISTING_DISCOUNT') {
              errorMessageEl.innerHTML = this.settings.dcErrorNotApplicableWithExistingDiscounts;
            } else {
              errorMessageEl.innerHTML = this.settings.dcErrorUnexpected;
              console.error(error);
            }
            errorMessageEl.classList.remove('invisible');
  
            // Reset apply button and checkout button
            loaderEl.style.display = 'none';
            buttonTextEl.style.display = 'block';
            e.target.disabled = false;
            this.checkoutButton.disabled = false;
  
            // Enable discount code input
            discountInputEl.disabled = false;
          }
        });
      }
    }

    // DISABLED (TLDEV-589). Kept for reference, do not re-enable as is: the write it
    // triggered always failed with 400 and retried forever. See the commented
    // updateDiscountKitProperties in cart-manager.js for the full explanation
    // async renderDiscountKitProperties() {
    //   if (window.cartManager.checkIfCartHasProductsWithDiscountKit()) {
    //     await window.cartManager.updateDiscountKitProperties();
    //   }
    // }

    async autoBundling() {
      await window.cartManager.autoBundling();
      window.broadcastChannel.dispatchEvent('render-cart-items', { openCartDrawer: false });
    }

    checkIfProductHasDiscountKitTag(item) {
      // Check if is CA
      let isCa = window.Shopify.country === 'CA';
      let dkBBDiscountTag = isCa ? window.cart_settings.dkBBDiscountTagCa : window.cart_settings.dkBBDiscountTag;
      let tags = item.properties._tags;

      // If US I need to avoid the tag 'bundle-discount-button-ca-', checking is the tag does not contain 'bundle-discount-button-ca-'
      if (!isCa) {
        tags = tags.filter(tag => !tag.includes(window.cart_settings.dkBBDiscountTagCa));
      }
      
      if(dkBBDiscountTag) {
        if(tags?.some(tag => tag.includes(dkBBDiscountTag))) {
          return true;
        }
      }
      return false;
    }

    getDkFilteredTags(item) {
      let isCa = window.Shopify.country === 'CA';
      let dkBBDiscountTag = isCa ? window.cart_settings.dkBBDiscountTagCa : window.cart_settings.dkBBDiscountTag;
      let tags = item.properties._tags || [];
      if (!isCa) {
        tags = tags.filter(tag => !tag.includes(window.cart_settings.dkBBDiscountTagCa));
      }
      return { tags, dkBBDiscountTag, isCa };
    }

    getDkBundleSuffix(item) {
      const { tags, dkBBDiscountTag } = this.getDkFilteredTags(item);
      if (!dkBBDiscountTag) return '';
      const discountTitleTag = tags?.find(tag => tag.includes(dkBBDiscountTag));
      return discountTitleTag ? (discountTitleTag.split(dkBBDiscountTag)[1] || '') : '';
    }

    /**
     * Suffix like "3-20%" or "3-20%-5-30%" or "3-20%-5-30" → [{ qty, pct }, ...]
     */
    parseDkPercentTiers(suffix) {
      if (!suffix || !suffix.includes('%')) return [];
      const parts = suffix.split('-');
      const tiers = [];
      for (let i = 0; i + 1 < parts.length; i += 2) {
        const qty = parseInt(parts[i], 10);
        const pctPart = parts[i + 1];
        if (!pctPart) break;
        const pct = parseInt(String(pctPart).replace(/%/g, ''), 10);
        if (Number.isNaN(qty) || Number.isNaN(pct)) break;
        tiers.push({ qty, pct });
      }
      return tiers;
    }

    /**
     * Sum qty for DK lines in the same %-vs-fixed pool.
     * Fixed: only lines without the fixed discount applied (unchanged).
     * Percent: always count every %-tagged line toward the next tier — tier-1 discount must not drop qty from the pool.
     */
    getEligibleDkQty(cart, isPercentMode) {
      let eligibleQty = 0;
      cart.items.forEach(cartItem => {
        if (!this.checkIfProductHasDiscountKitTag(cartItem)) return;
        if (this.checkIfProductHasDiscountKitPercentage(cartItem) !== isPercentMode) return;
        if (isPercentMode) {
          eligibleQty += cartItem.quantity;
        } else if (!this.checkIfProductHasDiscountKitApplied(cartItem)) {
          eligibleQty += cartItem.quantity;
        }
      });
      return eligibleQty;
    }

    /**
     * True when this %-DK line should show the gray minicart tier progress label.
     * Tiers are cumulative (no reset after the max tier): show whenever there is eligible qty.
     */
    hasRemainingPercentTier(item, cart) {
      if (!this.checkIfProductHasDiscountKitPercentage(item)) return false;
      const suffix = this.getDkBundleSuffix(item);
      const tiers = this.parseDkPercentTiers(suffix);
      if (!tiers.length) return false;
      const eligibleQty = this.getEligibleDkQty(cart, true);
      return eligibleQty > 0;
    }

    /**
     * Next tier the cart has not reached yet (cumulative qty across %-DK lines).
     * No cycling: once max tier qty is reached, returns null.
     */
    getNextPercentTier(suffix, eligibleQty) {
      const tiers = this.parseDkPercentTiers(suffix);
      if (!tiers.length) return null;
      const pool = eligibleQty;
      for (let t = 0; t < tiers.length; t++) {
        if (pool < tiers[t].qty) {
          const { qty, pct } = tiers[t];
          return {
            totalItemsToGetDiscount: qty,
            pct,
            inCycleQty: pool,
            discountTitle: `${qty} for ${pct}% Off`,
          };
        }
      }
      return null;
    }

    /**
     * Theme templates may use #line_break for a minicart line break (renders as &lt;br&gt;).
     * Literal newlines in the setting string are kept as line breaks too.
     */
    applyDiscountKitMiniCartLineBreakPlaceholders(text) {
      return String(text ?? '')
        .replaceAll('#line_break', '\n')
        .replace(/\r\n/g, '\n');
    }

    /** One line of progress: every word "Add" bold; rest in gray span. */
    appendDiscountKitMiniCartProgressSegment(el, segmentRaw) {
      const raw = String(segmentRaw ?? '').trim();
      if (!raw) return;

      const addRegex = /\badd\b/gi;
      const matches = [...raw.matchAll(addRegex)];
      if (!matches.length) {
        const span = document.createElement('span');
        span.className = 'js-cart-item-bundle-discount-kit-label__rest';
        span.textContent = raw;
        el.appendChild(span);
        return;
      }

      let cursor = 0;
      for (const m of matches) {
        const idx = m.index ?? -1;
        if (idx < 0) continue;

        const before = raw.slice(cursor, idx);
        if (/\S/.test(before)) {
          const span = document.createElement('span');
          span.className = 'js-cart-item-bundle-discount-kit-label__rest';
          span.textContent = before.trimStart();
          el.appendChild(span);
        }

        const strong = document.createElement('strong');
        strong.className = 'js-cart-item-bundle-discount-kit-label__progress';
        strong.textContent = raw.slice(idx, idx + m[0].length);
        el.appendChild(strong);

        cursor = idx + m[0].length;
      }

      const after = raw.slice(cursor);
      if (/\S/.test(after)) {
        const span = document.createElement('span');
        span.className = 'js-cart-item-bundle-discount-kit-label__rest';
        span.textContent = after.trimEnd();
        el.appendChild(span);
      }
    }

    /**
     * Minicart Discount Kit progress: every "Add" bold. Line breaks from #line_break or newline in the template.
     */
    setDiscountKitMiniCartProgressLabel(el, plainText) {
      if (!el) return;
      el.replaceChildren();
      const normalized = this.applyDiscountKitMiniCartLineBreakPlaceholders(String(plainText ?? ''));
      const lines = normalized
        .split('\n')
        .map((line) => line.trim())
        .filter((line) => line.length > 0);
      let firstLine = true;
      for (const line of lines) {
        if (!firstLine) el.appendChild(document.createElement('br'));
        firstLine = false;
        this.appendDiscountKitMiniCartProgressSegment(el, line);
      }
    }

    /**
     * Red label for the minicart. For %-tags with a line discount, use Shopify’s per-line
     * discount title (same source of truth as Liquid `item.message`); only fall back to
     * tag tiers + this line’s quantity when the title is missing.
     */
    getDiscountKitTagTitle(item, cart) {
      const { tags, dkBBDiscountTag } = this.getDkFilteredTags(item);

      if (dkBBDiscountTag) {
        const discountTitleTag = tags?.find(tag => tag.includes(dkBBDiscountTag));
        const suffix = discountTitleTag ? discountTitleTag.split(dkBBDiscountTag)[1] : '';
        if (suffix && suffix.includes('%')) {
          const tiers = this.parseDkPercentTiers(suffix);
          if (!tiers.length) return null;

          if (this.checkIfProductHasDiscountKitApplied(item)) {
            const lineTitle =
              item.discounts[0]?.title?.trim() ||
              (typeof item.message === 'string' ? item.message.trim() : '');
            if (lineTitle) return lineTitle;
            const q = item.quantity;
            let achieved = null;
            for (let i = tiers.length - 1; i >= 0; i--) {
              if (q >= tiers[i].qty) {
                achieved = tiers[i];
                break;
              }
            }
            if (achieved) {
              return `${achieved.qty} for ${achieved.pct}% Off`;
            }
            return `${tiers[0].qty} for ${tiers[0].pct}% Off`;
          }

          const activeCart = cart || window.cartManager?.getLocalCart();
          const eligibleQty = activeCart?.items ? this.getEligibleDkQty(activeCart, true) : 0;

          let achievedPartial = null;
          for (let i = tiers.length - 1; i >= 0; i--) {
            if (eligibleQty >= tiers[i].qty) {
              achievedPartial = tiers[i];
              break;
            }
          }
          if (achievedPartial) {
            return `${achievedPartial.qty} for ${achievedPartial.pct}% Off`;
          }
          return null;
        }
        return suffix ? suffix.replace('-', ' for $') : null;
      }

      return null;
    }

    checkIfProductHasDiscountKitPercentage(item) {
      const { tags, dkBBDiscountTag } = this.getDkFilteredTags(item);
      if (!dkBBDiscountTag) return false;
      const discountTag = tags?.find(tag => tag.includes(dkBBDiscountTag));
      return !!(discountTag && discountTag.includes('%'));
    }

    getDiscountQty(item) {
      const { tags, dkBBDiscountTag } = this.getDkFilteredTags(item);
      if (dkBBDiscountTag) {
        const discountQtyTag = tags?.find(tag => tag.includes(dkBBDiscountTag));
        return discountQtyTag ? discountQtyTag.split(dkBBDiscountTag)[1]?.split('-')[0] : null;
      }
      return null;
    }

    checkIfProductHasDiscountKitApplied(item) {
      if (!item.discounts?.length) return false;
      const discountTitle = item.discounts[0]?.title;
      if (!discountTitle) return false;
      if (this.checkIfProductHasDiscountKitPercentage(item)) {
        return discountTitle.includes('%');
      }
      return discountTitle.includes('for $');
    }

    checkMissingItems(cart, totalItemsToGetDiscount, isPercentMode = false) {
      const eligibleQty = this.getEligibleDkQty(cart, isPercentMode);
      if (eligibleQty > 0 && eligibleQty < totalItemsToGetDiscount) {
        return totalItemsToGetDiscount - eligibleQty;
      }
      return 0;
    }

    async renderCartItems(openCartDrawer = true) {
      let cart = window.cartManager?.getLocalCart();

      if (!cart.items?.length) {
        this.showEmptyCart();
        window.broadcastChannel.dispatchEvents(['update-cart-header-banners', 'update-cart-footer-prices', 'update-cart-badge', 'render-cart-upsells', 'render-cart-rebuy-upsells']);
        if (window.theme?.loyalty?.is_cart_loyalty_banner_displayed) {
          window.broadcastChannel.dispatchEvent('update-cart-loyalty-banner');
        }
        return;
      }

      if (this.itemsBlock.classList.contains('hidden')) {
        this.showItems();
      }

      if (cart.items.every(item => item.key !== this.settings.oosItemKey)) {
        delete this.dataset.oosItemKey;
        this.querySelector('.js-cart-error')?.classList.add('hidden');
      }

      const itemsComponentsEls = document.createElement("div");

      // Render cart items
      cart.items.forEach((item, index) => {

        const bundleId = item.properties._bundleId;
        const itemTemplate = this.querySelector('.js-template-cart-item').content?.cloneNode(true);
        const itemComponent = itemTemplate.querySelector('.js-component-cart-item');

        if (item.key === this.settings.oosItemKey) {
          itemComponent.querySelector('.js-cart-error-item').classList.remove('hidden');
          itemComponent.querySelector('.js-cart-item-button-plus').disabled = true;
          itemComponent.querySelector('.js-cart-item-button-minus').disabled = true;
          itemComponent.querySelector('.js-error-message-sold-out')?.classList.remove('hidden');
        }

        itemComponent.dataset.index = index;
        itemComponent.dataset.itemId = item.id;
        itemComponent.dataset.itemHandle = item.handle;
        itemComponent.dataset.itemKey = item.key;
        itemComponent.dataset.itemSellingPlanId = this.getSellingPlanId(item);
        itemComponent.dataset.isGwp = item.properties._isGWP === true;

        itemComponent.querySelector('.js-cart-item-title').textContent = item.product_title;

        const itemSizeEl = itemComponent.querySelector('.js-cart-item-size');
        if (itemSizeEl) {
          const opt1 = item.options_with_values[0]?.value;
          const opt2 = item.options_with_values[1]?.value;
          if (opt2 && opt2 !== 'Default Title' && opt1 && opt1 !== 'Default Title') {
            itemSizeEl.textContent += `${opt2} / ${opt1}`;
          } else if (opt1 && opt1 !== 'Default Title') {
            itemSizeEl.textContent = opt1;
          } else if (opt2 && opt2 !== 'Default Title') {
            itemSizeEl.textContent = opt2;
          }
        }

        if (item.properties._abId) {
          itemComponent.querySelector('.js-cart-item-bundle-quantity').textContent = `X${item.quantity}`;
          itemComponent.classList.add('auto-bundle-item');
        }

        const sellingPlanTextEl = itemComponent.querySelector('.js-cart-item-selling-plan');
        if (item.selling_plan_allocation?.selling_plan?.name) {
          sellingPlanTextEl.textContent = item.selling_plan_allocation.selling_plan.name;
        } else {
          sellingPlanTextEl.remove();
        }

        if (!index) {
          itemComponent.classList.add('first-item');
        } else if (!bundleId) {
          itemComponent.classList.add('border-top');
        }

        // Line item discounts
        let has_discount_kit_applied = false;
        let has_discount_kit_tag = false;
        let discountTitle = null;

        if(this.checkIfProductHasDiscountKitTag(item)) {
          has_discount_kit_tag = true;
          if(this.checkIfProductHasDiscountKitApplied(item)) {
            discountTitle = this.getDiscountKitTagTitle(item, cart);
            if(discountTitle) {
              has_discount_kit_applied = true;
            }
          }
        }

        if(this.settings.dkBBPdpEnabled) {
          
          // Fixed $: original mini cart template. %-discount progress: separate field (fallback to fixed template if empty); red label always discountTitle from Shopify.
          let labelTemplate = this.settings.dkBBMiniCartLabelTemplate;
          const percentTplRaw = (this.settings.dkBBMiniCartLabelTemplatePercent || '').trim();
          const percentBetweenTplRaw = (this.settings.dkBBMiniCartLabelTemplatePercentBetweenTiers || '').trim();
          const percentOneAwayTplRaw = (this.settings.dkBBMiniCartLabelTemplatePercentOneAway || '').trim();
          const percentMaxTplRaw = (this.settings.dkBBMiniCartLabelTemplatePercentMaxTier || '').trim();
          const hasMiniCartCopy =
            !!(
              labelTemplate ||
              percentTplRaw ||
              percentBetweenTplRaw ||
              percentOneAwayTplRaw ||
              percentMaxTplRaw
            );

          if(has_discount_kit_tag && hasMiniCartCopy) {

            const bundleKitLabelEl = itemComponent.querySelector('.js-cart-item-bundle-discount-kit-label');
            bundleKitLabelEl.textContent = '';
            bundleKitLabelEl.classList.add('hidden');

            const showPercentProgress =
              this.checkIfProductHasDiscountKitPercentage(item) && this.hasRemainingPercentTier(item, cart);
            const showFixedProgress =
              !this.checkIfProductHasDiscountKitPercentage(item) && !this.checkIfProductHasDiscountKitApplied(item);

            if (this.checkIfProductHasDiscountKitTag(item) && (showPercentProgress || showFixedProgress)) {

              if(this.checkIfProductHasDiscountKitPercentage(item)) {
                const suffix = this.getDkBundleSuffix(item);
                const tiers = this.parseDkPercentTiers(suffix);
                const pool = this.getEligibleDkQty(cart, true);
                const next = this.getNextPercentTier(suffix, pool);

                if (pool > 0 && tiers.length) {
                  let achieved = null;
                  for (let i = tiers.length - 1; i >= 0; i--) {
                    if (pool >= tiers[i].qty) {
                      achieved = tiers[i];
                      break;
                    }
                  }

                  let percentLabel = '';

                  if (!next && achieved) {
                    const tpl = (this.settings.dkBBMiniCartLabelTemplatePercentMaxTier || '').trim();
                    percentLabel = (tpl || 'Add more and still save #current_discount_percent%')
                      .replaceAll('#current_discount_percent', String(achieved.pct))
                      .replaceAll('#discount_percent', String(achieved.pct));
                  } else if (next && next.inCycleQty < next.totalItemsToGetDiscount) {
                    const missingQty = next.totalItemsToGetDiscount - next.inCycleQty;
                    const isBelowFirstTier = !achieved;

                    if (isBelowFirstTier) {
                      const tplRaw = (this.settings.dkBBMiniCartLabelTemplatePercent || '').trim();
                      const tpl = tplRaw && !tplRaw.includes('|||') ? tplRaw : 'Add #missing_items more to save #discount_percent%';
                      percentLabel = tpl
                        .replaceAll('#missing_items', String(missingQty))
                        .replaceAll('#discount_percent', String(next.pct))
                        .replaceAll('#discount_title', next.discountTitle)
                        .replaceAll('#current_discount_percent', '');
                    } else if (missingQty === 1) {
                      const tpl = (this.settings.dkBBMiniCartLabelTemplatePercentOneAway || '').trim();
                      percentLabel = (tpl || 'Add 1 more and save #discount_percent%')
                        .replaceAll('#missing_items', '1')
                        .replaceAll('#discount_percent', String(next.pct))
                        .replaceAll('#discount_title', next.discountTitle)
                        .replaceAll('#current_discount_percent', String(achieved.pct));
                    } else {
                      const tpl = (this.settings.dkBBMiniCartLabelTemplatePercentBetweenTiers || '').trim();
                      percentLabel = (tpl || 'Add 1 more and still save #current_discount_percent%.#line_break Add #missing_items or more and save #discount_percent%')
                        .replaceAll('#missing_items', String(missingQty))
                        .replaceAll('#discount_percent', String(next.pct))
                        .replaceAll('#discount_title', next.discountTitle)
                        .replaceAll('#current_discount_percent', String(achieved.pct));
                    }
                  }

                  if (percentLabel) {
                    this.setDiscountKitMiniCartProgressLabel(bundleKitLabelEl, percentLabel);
                    bundleKitLabelEl.classList.remove('hidden');
                  }
                }
              } else {
                let totalItemsToGetDiscount = this.getDiscountQty(item);

                if(totalItemsToGetDiscount && totalItemsToGetDiscount > 0) {
                  let missingQty = this.checkMissingItems(cart, +totalItemsToGetDiscount, false);
                  let discountTitle = this.getDiscountKitTagTitle(item, cart);

                  if(missingQty > 0 && discountTitle && labelTemplate) {

                    labelTemplate = labelTemplate.replace('#missing_items', missingQty);
                    labelTemplate = labelTemplate.replace('#discount_title', discountTitle);
                    this.setDiscountKitMiniCartProgressLabel(bundleKitLabelEl, labelTemplate);
                    bundleKitLabelEl.classList.remove('hidden');
                  }
                }
              }
            }
          }
        }

        if (bundleId) {
          itemComponent.dataset.bundleId = bundleId;
          itemComponent.classList.add('bundle-item');

          const pricesColumnEl = itemComponent.querySelector('.js-cart-item__prices-column');
          pricesColumnEl.classList.remove('component-cart-item__prices-column');
          pricesColumnEl.classList.remove('js-cart-item__prices-column');
          pricesColumnEl.classList.add('component-cart-item__prices-column-bundle');

          if (item.properties._first) {
            itemComponent.querySelector('.js-cart-item-quantity').textContent = item.quantity;
            itemComponent.classList.add('padding-top-0');

            if (item.properties._abId) {
              const abBundlesCount = cart.items
                .filter(item => item.properties._abId && item.properties._first)
                .reduce((acc, item) => acc + item.quantity, 0);

              // Stop if the Global AB Limit is reached
              if (abBundlesCount >= this.settings.abLimit) {
                itemComponent.querySelector('.auto-bundle-item .js-cart-item-button-plus').disabled = true;
              }

              const abTag = item.properties._abTag;

              const abBundleCountByTag = cart.items.reduce((acc, item) => {
                if (item.properties._abId && item.properties._tags?.includes(abTag) && item.properties._first) return acc + item.quantity;
                return acc;
              }, 0);

              const abLimitByTag = +abTag.split('-')[5];

              // Stop if the AB Tag Limit is reached
              if (abLimitByTag && abBundleCountByTag && abBundleCountByTag >= abLimitByTag) {
                itemComponent.querySelector('.auto-bundle-item .js-cart-item-button-plus').disabled = true;
              }
            }
          } else {
            itemComponent.querySelector('.js-quantity-selector')?.classList.add('invisible');
            itemComponent.querySelector('.js-cart-item-button-remove')?.classList.add('invisible');
          }

          if (item.properties._last) {
            itemComponent.classList.add('padding-bottom-0');

            if (index) {
              itemComponent.classList.add('border-top');
            }

            let bundlePrice = 0;
            let bundleComparePrice = 0;

            if (this.settings.countryCode === 'CA') {
              bundlePrice = +item.properties._bundlePriceCa * item.quantity;
            } else {
              bundlePrice = +item.properties._bundlePrice * item.quantity;
            }

            if ((item.properties._compareAtPrice && this.settings.countryCode === 'US') || (item.properties._compareAtPriceCa && this.settings.countryCode === 'CA')) {
              bundleComparePrice = cart.items.reduce((count, item) => {
                if (item.properties._bundleId === bundleId) return count + (item.price * item.quantity);
                return count;
              }, 0);
            }

            const bundlePriceEl = itemComponent.querySelector('.js-cart-bundle-price');
            const showBundleCompareAtPrice = this.settings.showBundleCompareAtPrice ? true : (item.properties._abId || item.properties._bbId) ? true : false;
            if (bundleComparePrice > bundlePrice && showBundleCompareAtPrice) {
              bundlePriceEl.textContent = `${toMoney(bundlePrice, { no_decimals: true })}`
              bundlePriceEl.classList.add('extra-margin-right');
              bundlePriceEl.classList.add('highlight');
              const bundleCompareAtPriceEl = itemComponent.querySelector('.js-cart-bundle-compare-at-price');
              bundleCompareAtPriceEl.textContent = `${toMoney(bundleComparePrice, { no_decimals: true })}`;
              bundleCompareAtPriceEl.classList.remove('hidden');
            } else if (bundleComparePrice && showBundleCompareAtPrice) {
              bundlePriceEl.textContent = `${toMoney(bundleComparePrice, { no_decimals: true })}`;
            } else {
              bundlePriceEl.textContent = `${toMoney(bundlePrice, { no_decimals: true })}`;
            }

            const bundleTitleEl = itemComponent.querySelector('.js-cart-bundle-title');
            const bundleItemsCount = cart.items.reduce((acc, item) => {
              if (item.properties._bundleId === bundleId) return acc + item.quantity;
              return acc;
            }, 0);
            let bundleTitle = '';
            if (item.properties._bundleTitle) {
              bundleTitle = item.properties._bundleTitle;
            } else if (item.properties._abId && this.settings.abTitle) {
              bundleTitle = this.settings.abTitle;
            } else if (item.properties._abId) {
              bundleTitle = `${bundleItemsCount / item.quantity} for ${toMoney(bundlePrice / item.quantity, { no_decimals: true })}`;
            }
            if (this.settings.abShowAmountOfProductsInTitle) {
              bundleTitle = `${bundleTitle}`;
              // bundleTitle = `${bundleTitle} ${this.settings.abShowAmountOfProductsInTitle ? `(${bundleItemsCount} products)` : ''}`;
            }
            bundleTitleEl.textContent = bundleTitle;
            bundleTitleEl.classList.add('grow');

            itemComponent.querySelector('.js-component-cart-item__bundle-header').classList.remove('hidden');
          }

          if (!item.properties._first && !item.properties._last) {
            itemComponent.classList.add('padding-bottom-top-0');
          }

          const promoExcludeEl = itemComponent.querySelector('.js-item-promo-exclude');
          if (promoExcludeEl && this.settings.sgdEnabled && item.properties._abId && item.properties._first && this.settings.sgdAbExcludeLabel) {
            promoExcludeEl.textContent = this.settings.sgdAbExcludeLabel;
            promoExcludeEl.classList.remove('hidden');
          }
        } else {

          itemComponent.querySelector('.js-cart-item-quantity').textContent = item.quantity;

          // Disable quantity selector if item is bundle button
          const isBundleButton = item.properties._bbId && item.properties._bbQuantity && item.properties._bbPrice && item.properties._bbPriceCa;

          // Block quantity selector if item is bundle button and not bundle button from discount kit
          if (isBundleButton && !item.properties._isBundleButtonDiscountKit) {
            itemComponent.querySelector('.js-cart-item-button-minus').disabled = true;
            itemComponent.querySelector('.js-cart-item-button-plus').disabled = true;
            itemComponent.querySelector('.js-cart-item_bb_label')?.classList.remove('hidden');
          }

          itemComponent.classList.add('single-item');

          if (item.quantity > 200) {
            itemComponent.querySelector('.js-cart-item-button-plus').disabled = true;
          }

          const priceEl = itemComponent.querySelector('.js-cart-item-cost');
          let itemPrice = item.price * item.quantity;

          if (has_discount_kit_applied) {
            itemPrice = item.final_line_price;
          }

          let bundleButtonPrice = 0;
          if (isBundleButton && this.settings.countryCode === 'CA') {
            bundleButtonPrice = item.properties._bbPriceCa;
          } else if (isBundleButton) {
            bundleButtonPrice = item.properties._bbPrice;
          }

          if (item.properties._isGWP) {
            itemComponent.querySelector('.js-cart-item-button-minus').disabled = true;
            itemComponent.querySelector('.js-cart-item-button-plus').disabled = true;
            priceEl.textContent = '$0';
            priceEl.classList.add('highlight');
            itemComponent.querySelector('.js-cart-item-free-label')?.classList.remove('hidden');
          } else if (isBundleButton && bundleButtonPrice) {
            if (bundleButtonPrice >=  itemPrice) {
              priceEl.textContent = `${toMoney(itemPrice, { no_decimals: true })}`;
            } else {
              priceEl.textContent = `${toMoney(bundleButtonPrice, { no_decimals: true })}`;
            }
          } else {
            priceEl.textContent = `${toMoney(itemPrice, { no_decimals: true })}`;
          }

          let compareAtPrice = null;
          if (itemPrice) {
            if (isBundleButton) {
              if (bundleButtonPrice < itemPrice) {
                compareAtPrice = item.original_price * item.quantity;
              }
            } else if (has_discount_kit_applied) {
              compareAtPrice = item.original_line_price;
            } else if (item.properties._isGWP) {
              compareAtPrice = item.original_price * item.quantity;
            } else if (item.properties._compareAtPriceCa && item.properties._compareAtPriceCa > item.price && this.settings.countryCode === 'CA') {
              compareAtPrice = item.properties._compareAtPriceCa;
            } else if (item.properties._compareAtPrice && item.properties._compareAtPrice > item.price && this.settings.countryCode === 'US') {
              compareAtPrice = item.properties._compareAtPrice;
            }

            const compareAtPriceEl = itemComponent.querySelector('.js-cart-item-compare-at-price');
            if (compareAtPriceEl) {
              if (isBundleButton && compareAtPrice) {
                compareAtPriceEl.textContent = `${toMoney(item.price * item.quantity, { no_decimals: true })}`;
                compareAtPriceEl.classList.remove('hidden');
                priceEl.classList.add('highlight');
              } 
              else if (has_discount_kit_applied) {
                compareAtPriceEl.textContent = `${toMoney(item.original_line_price, { no_decimals: true })}`;
                compareAtPriceEl.classList.remove('hidden');
                priceEl.classList.add('highlight');
              }
              else if (compareAtPrice || item.properties._isGWP) {
                compareAtPriceEl.textContent = compareAtPrice ? `${toMoney(compareAtPrice * item.quantity, { no_decimals: true })}` : `${toMoney(item.price * item.quantity, { no_decimals: true })}`;
                compareAtPriceEl.classList.remove('hidden');
                priceEl.classList.add('highlight');
              } else {
                compareAtPriceEl.remove();
              }
            }
          }

          const promoExcludeEl = itemComponent.querySelector('.js-item-promo-exclude');
          if (promoExcludeEl) {
            const productType = item.product_type.toLowerCase();
            if (this.settings.sgdEnabled && item.properties._isGWP && this.settings.sgdGwpExcludeLabel) {
              promoExcludeEl.textContent = this.settings.sgdGwpExcludeLabel;
              promoExcludeEl.classList.remove('hidden');
            } else if (this.settings.sgdEnabled && item.properties._tags?.includes(this.settings.sgdExcludeThresholdTagName) && item.selling_plan_allocation?.selling_plan?.id && this.settings.sgdSellingPlanExcludeLabel) {
              promoExcludeEl.textContent = this.settings.sgdSellingPlanExcludeLabel;
              promoExcludeEl.classList.remove('hidden');
            } else if (this.settings.sgdEnabled && item.properties._tags?.includes(this.settings.sgdExcludeThresholdTagName) && compareAtPrice && this.settings.sgdSaleItemExcludeLabel) {
              promoExcludeEl.textContent = this.settings.sgdSaleItemExcludeLabel;
              promoExcludeEl.classList.remove('hidden');
            } else if (this.settings.sgdEnabled && item.properties._tags?.includes(this.settings.sgdExcludeThresholdTagName) && this.settings.sgdTagExcludeLabel) {
              promoExcludeEl.textContent = this.settings.sgdTagExcludeLabel;
              promoExcludeEl.classList.remove('hidden');
            } else if (this.settings.sgdEnabled && item.properties._tags?.includes(this.settings.sgdExcludeThresholdTagName) && productType.includes('gift card') && this.settings.sgdGiftCardExcludeLabel) {
              promoExcludeEl.textContent = this.settings.sgdGiftCardExcludeLabel;
              promoExcludeEl.classList.remove('hidden');
            } else if (this.settings.bdEnabled && !this.settings.sgdEnabled && (this.settings.bdProductType === 'all' || this.settings.bdProductType === productType) && !item.properties._tags?.includes(this.settings.bdTag) && item.properties._isGWP && this.settings.bdGwpExcludeLabel) {
              promoExcludeEl.textContent = this.settings.bdGwpExcludeLabel;
              promoExcludeEl.classList.remove('hidden');
            } else if (this.settings.bdEnabled && !this.settings.sgdEnabled && (this.settings.bdProductType === 'all' || this.settings.bdProductType === productType) && item.selling_plan_allocation?.selling_plan?.id && this.settings.bdSellingPlanExcludeLabel) {
              promoExcludeEl.textContent = this.settings.bdSellingPlanExcludeLabel;
              promoExcludeEl.classList.remove('hidden');
            } else if (this.settings.bdEnabled && !this.settings.sgdEnabled && (this.settings.bdProductType === 'all' || this.settings.bdProductType === productType) && !item.properties._tags?.includes(this.settings.bdTag) && compareAtPrice && this.settings.bdSaleItemExcludeLabel) {
              promoExcludeEl.textContent = this.settings.bdSaleItemExcludeLabel;
              promoExcludeEl.classList.remove('hidden');
            } else if (this.settings.bdEnabled && !this.settings.sgdEnabled && (this.settings.bdProductType === 'all' || this.settings.bdProductType === productType) && !item.properties._tags?.includes(this.settings.bdTag) && this.settings.bdPromoExcludeLabel) {
              promoExcludeEl.textContent = this.settings.bdPromoExcludeLabel;
              promoExcludeEl.classList.remove('hidden');
            } else if (this.settings.bdEnabled && !this.settings.sgdEnabled && productType.includes('gift card') && !item.properties._tags?.includes(this.settings.bdTag) && this.settings.bdGiftCardExcludeLabel) {
              promoExcludeEl.textContent = this.settings.bdGiftCardExcludeLabel;
              promoExcludeEl.classList.remove('hidden');
            } else {
              promoExcludeEl.classList.add('hidden');
            }
          }
        }

        let imageSrc = item.image;
        if (imageSrc.includes('.jpg?v=')) {
          const imagePathParts = imageSrc.split('.jpg?v=');
          const imageName = imagePathParts[0].split('/').pop();
          imageSrc = `https://${window.location.host}/cdn/shop/${ imageSrc.includes('/products/') ? 'products': 'files'}/` + imageName + '_168x.jpg?v=' + imagePathParts[1];
        }
        const imageEl = itemComponent.querySelector('.js-cart-item-image');
        imageEl.src = imageSrc;
        imageEl.alt = item.product_title;

        if (item.product_type.toLowerCase().includes('gift card')) {
          imageEl.classList.add('gift-card');
        }

        if (bundleId && !item.properties._first && !item.properties._last) {
          imageEl.classList.add('border-radious-none');
        } else if (bundleId && item.properties._first) {
          imageEl.classList.add('border-radious-bottom');
        } else if (bundleId && item.properties._last) {
          imageEl.classList.add('border-radious-top');
        }

        if (!(item.properties._isGWP && !this.settings.gwpLinkEnabled)) {
          const linksEls = itemComponent.querySelectorAll('.js-cart-item-link');
          linksEls.forEach(linkEl => {
            if (bundleId) {
              linkEl.href = `${window.Shopify.routes.root}products/${item.properties._bundleProduct}`;
            } else {
              linkEl.href = item.url.split('?')[0];
            }
          });
        }

        const finalSaleLabelEl = itemComponent.querySelector('.js-cart-item-final-sale');
        if (finalSaleLabelEl && item.properties._tags?.some(tag => tag.toLowerCase().replaceAll(/\s|-|_/g, '').includes('finalsale')) && !bundleId && !item.properties._isGWP && !item.product_type.toLowerCase().includes('gift card')) {
          finalSaleLabelEl.textContent = this.settings.finalSaleLabel;
          finalSaleLabelEl.classList.remove('hidden');
        } else {
          finalSaleLabelEl.remove();
        }

        if(this.settings.dkBBPdpEnabled) {
          const discountLabelEl = itemComponent.querySelector('.js-cart-item-discount');

          if (discountLabelEl && has_discount_kit_applied) {
            discountLabelEl.textContent = discountTitle;
            discountLabelEl.classList.remove('hidden');
          } else {
            discountLabelEl.textContent = "";
            discountLabelEl.classList.add('hidden');
            //discountLabelEl.remove();
          }
        }

        itemsComponentsEls.append(itemTemplate);
      });

      if (this.settings.gwpEnabled) {
        const cart = window.cartManager.getLocalCart();
        const gwpExcludeProductTypeListArray = this.settings.gwpExcludeProductTypeList?.length ? this.settings.gwpExcludeProductTypeList.split(',').filter(item => !!item).map(item => item.toLocaleLowerCase()) : null;

        let cartTotalPrice = cart.items.reduce((cartTotal, item) => {
          const productType = item.product_type.toLowerCase();
          if (this.settings.gwpExcludeTag && item.properties._tags?.includes(this.settings.gwpExcludeTag)) {
            return cartTotal;
          } else if (gwpExcludeProductTypeListArray?.includes(productType)) {
            return cartTotal;
          } else if (item.properties._isGWP && !this.settings.gwpThresholdUseTotal) {
            return cartTotal;
          } else if (!this.settings.gwpIncludeTag || (this.settings.gwpIncludeTag && item.properties._tags?.includes(this.settings.gwpIncludeTag))) {
            return cartTotal + item.price * item.quantity;
          } else {
            return cartTotal;
          }
        }, 0);

        if (this.settings.gwpThresholdUseTotal) {
          cartTotalPrice -= cart.discount;
        }

        // Remove GWP products if needed
        const updateCart = await this.updateGWP(cartTotalPrice);
        if (updateCart) {
          window.broadcastChannel.dispatchEvent('render-cart-items', {openCartDrawer: false});
          return;
        }

        // Render GWP Box
        await this.updateGWPBox(cartTotalPrice);
      }

      if (this.settings.showClearCartButton) {
        this.clearCartButton.classList.remove('hidden');
      }

      this.itemsBlock.innerHTML = itemsComponentsEls.innerHTML;

      window.broadcastChannel.dispatchEvents(['update-cart-header-banners', 'update-cart-footer-prices', 'update-cart-badge', 'render-cart-upsells', 'render-cart-rebuy-upsells']);

      if (window.theme?.loyalty?.is_cart_loyalty_banner_displayed) window.broadcastChannel.dispatchEvent('update-cart-loyalty-banner');

      openCartDrawer && window.dispatchEvent(new CustomEvent('open-cart-drawer'));
    }

    async updateGWP(cartTotalPrice) {
      return new Promise(async resolve => {
        const cart = window.cartManager.getLocalCart();
        const gwpProductsInCart = cart.items.filter(item => item.properties._isGWP);
        const gwpHandles = [this.settings.gwpFirstGift, this.settings.gwpSecondGift, this.settings.gwpThirdGift].filter(item => !!item);
        const diff1 = this.settings.gwpFirstThreshold - cartTotalPrice;
        const diff2 = this.settings.gwpSecondThreshold - cartTotalPrice;
        const diff3 = this.settings.gwpThirdThreshold - cartTotalPrice;

        if (!gwpProductsInCart.length) resolve(false);

        let updateCart = false;
        for (let i = 0; i < gwpProductsInCart.length; i++) {
          const item = gwpProductsInCart[i];
          if (gwpHandles.every(gwphandle => gwphandle != item.handle)) {
            await window.cartManager.removeItem(item.key);
            updateCart = true;
          } else if (diff3 > 0 && item.handle === this.settings.gwpThirdGift) {
            await window.cartManager.removeItem(item.key);
            updateCart = true;
          } else if (diff2 > 0 && item.handle === this.settings.gwpSecondGift) {
            await window.cartManager.removeItem(item.key);
            updateCart = true;
          } else if (diff1 > 0) {
            await window.cartManager.removeItem(item.key);
            updateCart = true;
          }
        }
        resolve(updateCart);
      });
    }

    async updateGWPBox(cartTotalPrice) {
      const cart = window.cartManager.getLocalCart();
      const gwpProductsHandles = cart.items.filter(item => item.properties._isGWP).map(item => item.handle);
      const gwpBoxEl = this.querySelector('.js-component-cart-gwp-box');
      const diff1 = this.settings.gwpFirstThreshold - cartTotalPrice;
      const diff2 = this.settings.gwpSecondThreshold - cartTotalPrice;
      const diff3 = this.settings.gwpThirdThreshold - cartTotalPrice;

      if (this.settings.gwpMultipleGiftEnabled && this.settings.gwpThirdThreshold > 0 && diff3 <= 0) {
        if (!gwpBoxEl && !gwpProductsHandles.includes(this.settings.gwpThirdGift)) {
          try {
            await this.renderGWPBox(this.settings.gwpThirdGift, this.settings.gwpThirdGiftVariant, 3);
            return;
          } catch(err) {
            console.error(err);
            return;
          }
        } else if (gwpBoxEl && gwpBoxEl.dataset.product !== this.settings.gwpThirdGift && !gwpProductsHandles.includes(this.settings.gwpThirdGift)) {
          try {
            await this.renderGWPBox(this.settings.gwpThirdGift, this.settings.gwpThirdGiftVariant, 3);
            return;
          } catch(err) {
            console.error(err);
            return;
          }
        } else if (gwpBoxEl && gwpBoxEl.dataset.product === this.settings.gwpThirdGift && !gwpProductsHandles.includes(this.settings.gwpThirdGift)) {
          return;
        } else if (gwpBoxEl && gwpBoxEl.dataset.product === this.settings.gwpThirdGift && gwpProductsHandles.includes(this.settings.gwpThirdGift)) {
          gwpBoxEl.remove();
        }
      }
      if (this.settings.gwpMultipleGiftEnabled && this.settings.gwpSecondThreshold > 0 && diff2 <= 0) {
        if (this.settings.gwpThirdThreshold > 0 && diff3 <= 0 && gwpProductsHandles.includes(this.settings.gwpThirdGift) && this.settings.gwpOnlyOneGiftEnabled) return;
        if (!gwpBoxEl && !gwpProductsHandles.includes(this.settings.gwpSecondGift)) {
          try {
            await this.renderGWPBox(this.settings.gwpSecondGift, this.settings.gwpSecondGiftVariant, 2);
            return;
          } catch(err) {
            console.error(err);
            return;
          }
        } else if (gwpBoxEl && gwpBoxEl.dataset.product !== this.settings.gwpSecondGift && !gwpProductsHandles.includes(this.settings.gwpSecondGift)) {
          try {
            await this.renderGWPBox(this.settings.gwpSecondGift, this.settings.gwpSecondGiftVariant, 2);
            return;
          } catch(err) {
            console.error(err);
            return;
          }
        } else if (gwpBoxEl && gwpBoxEl.dataset.product === this.settings.gwpSecondGift && !gwpProductsHandles.includes(this.settings.gwpSecondGift)) {
          return;
        } else if (gwpBoxEl && gwpBoxEl.dataset.product === this.settings.gwpSecondGift && gwpProductsHandles.includes(this.settings.gwpSecondGift)) {
          gwpBoxEl.remove();
        } else if (gwpBoxEl && gwpBoxEl.dataset.product === this.settings.gwpThirdGift) {
          gwpBoxEl.remove();
        }
      }
      if (this.settings.gwpFirstThreshold > 0 && diff1 <= 0) {
        if (this.settings.gwpSecondThreshold > 0 && diff2 <= 0 && gwpProductsHandles.includes(this.settings.gwpSecondGift) && this.settings.gwpOnlyOneGiftEnabled) return;
        if (!gwpBoxEl && !gwpProductsHandles.includes(this.settings.gwpFirstGift)) {
          try {
            await this.renderGWPBox(this.settings.gwpFirstGift, this.settings.gwpFirstGiftVariant, 1);
            return;
          } catch(err) {
            console.error(err);
            return;
          }
        } else if (gwpBoxEl && gwpBoxEl.dataset.product !== this.settings.gwpFirstGift && !gwpProductsHandles.includes(this.settings.gwpFirstGift)) {
          try {
            await this.renderGWPBox(this.settings.gwpFirstGift, this.settings.gwpFirstGiftVariant, 1);
            return;
          } catch(err) {
            console.error(err);
            return;
          }
        } else if (gwpBoxEl && gwpBoxEl.dataset.product === this.settings.gwpFirstGift && !gwpProductsHandles.includes(this.settings.gwpFirstGift)) {
          return;
        } else if (gwpBoxEl && gwpBoxEl.dataset.product === this.settings.gwpFirstGift && gwpProductsHandles.includes(this.settings.gwpFirstGift)) {
          gwpBoxEl.remove();
          return;
        } else if (gwpBoxEl && gwpBoxEl.dataset.product === this.settings.gwpSecondGift) {
          gwpBoxEl.remove();
          return;
        } else if (gwpBoxEl && gwpBoxEl.dataset.product === this.settings.gwpThirdGift) {
          gwpBoxEl.remove();
          return;
        }
      }
      if (gwpBoxEl && diff1 > 0) {
        gwpBoxEl.remove();
      }
    }

    async renderGWPBox(productHandler, variantId = null, giftNum = 1) {
      return new Promise(async (resolve, reject) => {
        const currentGift = giftNum === 3 ? 'thirdGift' : giftNum === 2 ? 'secondGift' : 'firstGift';
        if (!this.state[currentGift]) {
          const response = await fetch(`${window.Shopify.routes.root}products/${productHandler}.js`, {
            method: 'get'
          });

          if (!response.ok) {
            reject(`Error fetching product! Status: ${response.status}`);
            return;
          }

          this.state[currentGift] = await response.json();

          if (!this.state[currentGift]) {
            reject('Gift with purchase not found');
            return;
          }
        }

        const product = this.state[currentGift];

        if (variantId && !product.variants.some(variant => variant.id === variantId)) {
          console.error('GWP: variantId doesn\'t match with product\'s variants.');
          variantId = null;
        }

        let variant = variantId ? product.variants.find(variant => variant.id === variantId) : null;

        if (product.variants.length === 1) {
          variant = product.variants[0];
        }

        let gwpOutOfStockCurrentThreshold = 0;
        let gwpTrueSize = false;
        if (giftNum === 1) {
          gwpOutOfStockCurrentThreshold = this.settings.gwpOutOfStockFirstThreshold || 0;
          gwpTrueSize = this.settings.gwpFirstTrueSize;
        } else if (giftNum === 2) {
          gwpOutOfStockCurrentThreshold = this.settings.gwpOutOfStockSecondThreshold || 0;
          gwpTrueSize = this.settings.gwpSecondTrueSize;
        } else {
          gwpOutOfStockCurrentThreshold = this.settings.gwpOutOfStockThirdThreshold||0;
          gwpTrueSize = this.settings.gwpThirdTrueSize;
        }

        if (!variant) {
          if (product.variants.every(variant => {
            if (variant.inventory_quantity <= this.settings.outOfStockThreshold && variant.inventory_policy != 'continue' && !product.tags.includes('inventory_threshold_ignore')) {
              return true;
            }
          })) {
            reject('Gift with purchase out of stock');
            return;
          }

          if (product.variants.every(variant => {
            if (variant.inventory_quantity <= gwpOutOfStockCurrentThreshold) {
              return true;
            }
          })) {
            reject('Gift with purchase stock limit reached');
            return;
          }
        }

        if (variant && variant.inventory_quantity <= gwpOutOfStockCurrentThreshold) {
          reject('Gift with purchase stock limit reached');
          return;
        }

        if (variant && variant.inventory_policy != 'continue' && !product.tags.includes('inventory_threshold_ignore') && (variant.inventory_quantity <= this.settings.outOfStockThreshold)) {
          reject('Gift with purchase out of stock');
          return;
        }

        const gwpTemplate = this.querySelector('.js-template-cart-gwp')?.content?.cloneNode(true);

        if (!gwpTemplate) {
          reject('No template');
          return;
        }

        gwpTemplate.querySelector('.js-component-cart-gwp-box').dataset.product = product.handle;
        const boxTitle = giftNum === 1 ? this.settings.gwpFirstBoxTitle : giftNum === 2 ? this.settings.gwpSecondBoxTitle : this.settings.gwpThirdBoxTitle;
        gwpTemplate.querySelector('.js-cart-gwp-box-title').textContent = boxTitle || this.settings.gwpFirstBoxTitle;
        gwpTemplate.querySelector('.js-cart-gwp-title').textContent = product.title;

        const imageEl = gwpTemplate.querySelector('.js-cart-gwp-image');
        const innerWidth = window.innerWidth;
        let src = product.images[0]?.split('.jpg');
        src = src[0] + (innerWidth < 768 ? '_190x.jpg' : '_240x.jpg') + src[1];
        imageEl.src = src;
        imageEl.alt = product.title;

        if (this.settings.gwpLinkEnabled) {
          gwpTemplate.querySelectorAll('.js-cart-gwp-link').forEach(linkEl => {
            linkEl.href = `/products/${product.handle}`;
          });
        }

        const addGWPButton = gwpTemplate.querySelector('.js-cart-gwp-button-add');
        let sizeColorText = '';

        if (variant) {
          if (variant.option2 && variant.option1) {
            sizeColorText = `${variant.option2} / ${variant.option1}`;
          } else if (variant.option2) {
            sizeColorText = `${variant.option2}`;
          } else if (variant.option1) {
            sizeColorText = `${variant.option1}`;
          }

          if(sizeColorText == "Default Title") {
            sizeColorText = "One Size";
          }

          gwpTemplate.querySelector('.js-cart-gwp-size-color').textContent = sizeColorText;
        } else if (product.variants.length > 1) {
          let optionsEls = '<option value="" disabled selected>Select size</option>';

          const underwearSize = this.settings.trueSize?.underwearSize || null;
          const braSize = this.settings.trueSize?.braSize || null;

          product.variants.forEach((variant) => {
            let selected = false;
            if (gwpTrueSize) {
              const productType = product.type.toLowerCase();
              const isForm360 = product.tags.includes('precise_sizing');
              const mappedSize = (braSize && isForm360) ? getMappedFormfitSize(braSize) : null;
              const mappedSizeAlpha = (braSize && productType !== 'bra' && product.tags.includes('alpha')) ? getMappedAlphaSize(braSize) : null;

              if (braSize && productType === 'bra' && variant.option2 === braSize) {
                selected = true;
              } else if (underwearSize && productType === 'panties' && variant.option2 === underwearSize) {
                selected = true;
              } else if (mappedSize && variant.option2 === mappedSize) {
                selected = true;
              } else if (mappedSizeAlpha && variant.option2 === mappedSizeAlpha) {
                selected = true;
              }

              if (selected) {
                addGWPButton.disabled = false;
              }
            }

            if ((variant.option2 || variant.option1) && (variant.inventory_policy == 'continue' || product.tags.includes('inventory_threshold_ignore') || variant.inventory_quantity > this.settings.outOfStockThreshold)) {
              if ((variant.inventory_quantity > gwpOutOfStockCurrentThreshold)) {
                optionsEls += `<option ${selected ? 'selected' : ''} value="${variant.option2 || variant.option1}">${variant.option2 || variant.option1}</option>`;
              }
            }
          });

          const productSizeEl = gwpTemplate.querySelector('.js-cart-gwp-size-color');
          productSizeEl && productSizeEl.insertAdjacentHTML('beforeend', `<select class="component-cart-gwp__size-select js-cart-gwp-size-select">${optionsEls}</select>`);
          productSizeEl.innerHTML += `<span> / ${product.variants[0].option1}</span>`;

          const sizeSelectEl = gwpTemplate.querySelector('.js-cart-gwp-size-select');
          addGWPButton && sizeSelectEl.addEventListener('change', () => {
            addGWPButton.disabled = false;
          });
        }

        const compareAtPrice = variant?.price || product.variants[0].price;
        const compareAtPriceEl = gwpTemplate.querySelector('.js-cart-gwp-compare-at-price');
        if (compareAtPrice) {
          compareAtPriceEl.textContent = `${variant ? toMoney(variant.price) : toMoney(product.variants[0].price)}`;
        } else {
          compareAtPriceEl.remove();
        }

        addGWPButton && addGWPButton.addEventListener('click', async () => {
          addGWPButton.disabled = true;
          let currentVariant = variant;

          if (!currentVariant) {
            const sizeSelectEl = this.querySelector('.js-cart-gwp-size-select');
            const selectSize = sizeSelectEl.options[sizeSelectEl.selectedIndex]?.value;
            currentVariant = product.variants.find(variant => (variant.option2 || variant.option1) === selectSize);
          }

          if (!currentVariant) {
            console.error('Error adding GWP');
            return;
          }

          if (this.settings.gwpOnlyOneGiftEnabled) {
            const cart = window.cartManager.getLocalCart();
            const gwpProducts = cart.items.filter(item => item.properties._isGWP);
            for (let i = 0; i < gwpProducts.length; i++) {
              const item = gwpProducts[i];
              await window.cartManager.removeItem(item.key);
            }
          }

          const payload = {
            id: currentVariant.id,
            quantity: 1,
            properties: {
              _isGWP: true,
              _tags: filterProductTags(product.tags)
            }
          };

          const compareAtPrice = currentVariant?.compare_at_price;
          const price = currentVariant?.price;
          if (window.Shopify.country === 'CA' && compareAtPrice && compareAtPrice > price) {
            payload.properties._compareAtPrice = Math.trunc((compareAtPrice / 100) / window.i18n_cad_exchange_rate) * 100;
            payload.properties._compareAtPriceCa = compareAtPrice;
          } else if (compareAtPrice && compareAtPrice > price) {
            payload.properties._compareAtPrice = compareAtPrice;
            payload.properties._compareAtPriceCa = Math.ceil((compareAtPrice / 100) * window.i18n_cad_exchange_rate) * 100;
          }

          await window.cartManager.addItem(payload);

          window.dispatchEvent(new CustomEvent('update-cart'));

          // Send GWP GTM data
          window.sendGTMData && window.sendGTMData({
            event: 'gwp_add_to_cart',
            source: 'cart-drawer',
            product_id: product.id,
            variant_id: currentVariant.id,
            product_name: product.title,
            product_handle: product.handle
          });
        });

        if (addGWPButton && variant) {
          addGWPButton.disabled = false;
        }

        const recommendationsEl = this.querySelector('.js-ups');
        if (this.querySelector('.js-component-cart-gwp-box')) {
          this.querySelector('.js-component-cart-gwp-box').remove();
        }
        if (this.settings.gwpPosition === 'top') {
          this.itemsBlock.before(gwpTemplate);
          if (this.settings.upsEnabled && recommendationsEl && this.settings.upsPosition === 'top') {
            recommendationsEl.after(gwpTemplate);
          } else {
            this.itemsBlock.before(gwpTemplate);
          }
        } else {
          if (this.settings.upsEnabled && recommendationsEl && this.settings.upsPosition === 'bottom') {
            recommendationsEl.before(gwpTemplate);
          } else {
            this.itemsBlock.after(gwpTemplate);
          }
        }

        resolve('OK');
      });
    }

    showItems() {
      this.itemsBlock.classList.remove('hidden');
      this.emptyCart.classList.add('hidden');

      if (window.theme?.loyalty?.is_rewards_banner_displayed) {
        window.dispatchEvent(new CustomEvent('update-rewards-banner'));
      }

      if (this.settings.hideFooterOnEmptyCart) {
        window.broadcastChannel.dispatchEvent('show-cart-footer');
      }

      if (this.settings.upsEmptyCartEnabled) {
        this.recContainerEl?.remove();
        this.style.justifyContent = 'flex-start';
      }
    }

    showEmptyCart() {
      if (window.theme?.loyalty?.is_rewards_banner_displayed) {
        window.dispatchEvent(new CustomEvent('update-rewards-banner'));
      }

      if (this.settings.upsEnabled) {
        this.recContainerEl?.remove();
        this.style.justifyContent = 'flex-start';
      }

      this.itemsBlock.classList.add('hidden');
      this.emptyCart.classList.remove('hidden');

      if (this.settings.showClearCartButton) {
        this.clearCartButton.classList.add('hidden');
      }

      if (this.settings.hideFooterOnEmptyCart) {
        window.broadcastChannel.dispatchEvent('hide-cart-footer');
      }

      this.querySelector('.js-component-cart-gwp-box')?.remove();
      this.querySelector('.js-cart-error')?.remove();
    }

    redirectTo(url) {
      window.location.href = url;
    }

    getSellingPlanId(item) {
      return item.selling_plan_allocation ? item.selling_plan_allocation.selling_plan.id : null;
    }

    async showUpsells(isEmptyCart = false) {
      const cart = window.cartManager?.getLocalCart();
      const productId = cart?.items?.length > 0 ? cart.items[0]?.product_id : this.settings.upsEmptyCartProductId;
      const intent = cart?.items?.length > 0 ? this.settings.upsRecIntent : this.settings.upsEmptyCartRecIntent;

      if (
        this.settings.upsShowFixedProducts && this.settings.upsFixedProducts?.length && !isEmptyCart
        || this.settings.upsEmptyCartShowFixedProducts && this.settings.upsEmptyCartFixedProducts?.length && isEmptyCart
      ) {
        try {
          const fixedProducts = JSON.parse(sessionStorage.getItem(`upsells_fixed_products${isEmptyCart ? '_empty_cart' : ''}`) || '[]');
          const cacheTime = isEmptyCart ? this.settings.upsEmptyCartFixedProductsCacheTime : this.settings.upsFixedProductsCacheTime;
          if (fixedProducts?.products?.length && cacheTime && (Date.now() - fixedProducts?.date < 1000 * 60 * cacheTime)) {
            setTimeout(() => this.renderUpsells(fixedProducts.products, isEmptyCart), 0);
          } else {
            const products = [];
            const upsNumOfProd = isEmptyCart ? (this.settings.upsEmptyCartNumOfProd || 10) : (this.settings.upsNumOfProd || 10);
            const productsHandles = isEmptyCart ? this.settings.upsEmptyCartFixedProducts : this.settings.upsFixedProducts;
            const limit = upsNumOfProd <= productsHandles.length ? upsNumOfProd : productsHandles.length;
            for (let i = 0; i < limit; i++) {
              let response = await fetch(`${window.Shopify.routes.root}products/${productsHandles[i]}.js`);
              if (response.ok) {
                response = await response.json();
                products.push(response);
              }
            }
            if (products?.length) {
              sessionStorage.setItem(`upsells_fixed_products${isEmptyCart ? '_empty_cart' : ''}`, JSON.stringify({products, date: Date.now()}));
              this.renderUpsells(products, isEmptyCart);
            } else {
              sessionStorage.removeItem(`upsells_fixed_products${isEmptyCart ? '_empty_cart' : ''}`);
            }
          }
        } catch(err) {
          sessionStorage.removeItem(`upsells_fixed_products${isEmptyCart ? '_empty_cart' : ''}`);
          console.error(err);
        }
      } else if (productId) {
        sessionStorage.removeItem(`upsells_fixed_products${isEmptyCart ? '_empty_cart' : ''}`);
        const limit = this.settings.upsNumOfProd ? this.settings.upsNumOfProd : 10;
        fetch(window.Shopify.routes.root + `recommendations/products.json?product_id=${productId}&limit=${limit}&intent=${intent}`)
        .then(response => response.json())
        .then((response) => {
          if (response.products) {
            this.renderUpsells(response.products, isEmptyCart);
          }
        }).catch((error) => {
          console.error(error);
        });
      }
    }

    renderUpsells(_products, isEmptyCart) {
      const cartItemsAmount = window.cartManager?.getLocalCart()?.items?.length || 0;
      const underwearSize = this.settings.trueSize?.underwearSize || null;
      const braSize = this.settings.trueSize?.braSize || null;
      let products = [];

      if (!isEmptyCart && this.settings.upsOnlyTrueSizeEnabled || isEmptyCart && this.settings.upsEmptyCartOnlyTrueSizeEnabled) {
        if (this.settings.trueSize) {
          products = _products.filter(prod => {
            const productType = prod.type?.trim().toLowerCase();
            const isForm360 = prod.tags.includes('precise_sizing');
            const mappedSize = (braSize && isForm360) ? getMappedFormfitSize(braSize) : null;
            const mappedSizeAlpha = (braSize && productType !== 'bra' && prod.tags.includes('alpha')) ? getMappedAlphaSize(braSize) : null;

            if (isEmptyCart && prod.tags.some(tag => this.settings.upsEmptyCartOnlyTrueSizeEnabledExceptionTags.includes(tag))) {
              return true;
            } else if (!isEmptyCart && prod.tags.some(tag => this.settings.upsOnlyTrueSizeEnabledExceptionTags.includes(tag))) {
              return true;
            }

            return prod.variants.some(variant => {
              if (!variant.available) return false;
              if (braSize && productType === 'bra' && variant.option2 === braSize) {
                return true;
              } else if (underwearSize && (productType === 'panties' || productType === 'sleepwear') && variant.option2 === underwearSize) {
                return true;
              } else if (mappedSize && variant.option2 === mappedSize) {
                return true;
              } else if (mappedSizeAlpha && variant.option2 === mappedSizeAlpha) {
                return true;
              }
              return false;
            });
          });
        } else if (!isEmptyCart && this.settings.upsNoTrueSizeShowProducts || isEmptyCart && this.settings.upsEmptyCartNoTrueSizeShowProducts) {
          products = [..._products];
        }
      } else {
        products = [..._products];
      }

      this.recContainerEl?.remove();

      if (!products.length) return;

      this.recContainerEl = this.querySelector('.js-template-recommendations')?.content?.cloneNode(true).querySelector('.js-ups');

      if (isEmptyCart && this.settings.upsEmptyCartTitle) {
        this.recContainerEl.querySelector('.component-cart-body__ups__title').textContent = this.settings.upsEmptyCartTitle;
      } else if (!isEmptyCart && this.settings.upsTitle) {
        this.recContainerEl.querySelector('.component-cart-body__ups__title').textContent = this.settings.upsTitle;
      } else {
        this.recContainerEl?.querySelector('.component-cart-body__ups__title')?.remove();
      }

      if (products.length <= 3) this.recContainerEl?.querySelector('.button-wrap')?.remove();

      const sliderEl = this.recContainerEl?.querySelector('.js-ups-slider');

      if (sliderEl && sliderEl.childNodes.length) {
        sliderEl.innerHTML = '';
      }

      const addClickEvent = (ele, prod) => {
        ele.addEventListener('click', () => {
          const url = `https://${window.Shopify.shop}${window.Shopify.routes.root}products/${prod.handle}`;

          window.sendGTMData && window.sendGTMData({
            event: 'cart_recommendation_click',
            source: 'cart-drawer',
            product_id: prod.id,
            product_name: prod.title,
            product_url: url
          });
        });
      };

      products.forEach((prod, index) => {
        const productRecommendation = this.querySelector('.js-template-ups-product') ? this.querySelector('.js-template-ups-product').content?.cloneNode(true) : null;
        
        if (!productRecommendation) return;
        
        const imageLink = productRecommendation.querySelector('.js-recommendation-product-image-link');
        const url = `https://${window.Shopify.shop}${window.Shopify.routes.root}products/${prod.handle}`;
        imageLink.href = url;
        addClickEvent(imageLink, prod);

        const imageEl = productRecommendation.querySelector('.js-recommendation-product-image');
        imageEl.alt = prod.image?.alt || prod.title;

        let src = prod.images[0].split('.jpg');
        const innerWidth = window.innerWidth;
        src = src[0] + (innerWidth < 768 ? '_190x.jpg' : '_240x.jpg') + src[1];
        const indexThreshold = window.innerWidth < 992 ? 3 : 2;
        if (cartItemsAmount > 5 || index > indexThreshold) {
          imageEl.dataset.src = src;
          imageEl.classList.add('lazyload');
        } else {
          imageEl.src = src;
        }

        const nameEl = productRecommendation.querySelector('.js-recommendation-product-title');
        nameEl.textContent = prod.title;
        nameEl.href = url;
        addClickEvent(nameEl, prod);

        const priceEl = productRecommendation.querySelector('.js-recommendation-product-price');
        priceEl.textContent = toMoney(prod.variants[0].price);

        // Add add-to-cart button
        const sizeSelectEl = productRecommendation.querySelector('.js-recommendation-product-size-select');
        const addToCartButtonEl = productRecommendation.querySelector('.js-recommendation-product-add-to-cart-button');
        if ((!isEmptyCart && this.settings.upsShowAddToCartButton) || (isEmptyCart && this.settings.upsEmptyCartShowAddToCartButton)) {
          if (isEmptyCart) {
            addToCartButtonEl.textContent = this.settings.upsEmptyCartAddToCartButtonLabel;
          } else {
            addToCartButtonEl.textContent = this.settings.upsAddToCartButtonLabel;
          }

          const productType = prod.type.toLowerCase();
          const isForm360 = prod.tags.includes('precise_sizing');
          const mappedSize = (braSize && isForm360) ? getMappedFormfitSize(braSize) : null;
          const mappedSizeAlpha = (braSize && productType !== 'bra' && prod.tags.includes('alpha')) ? getMappedAlphaSize(braSize) : null;
          let trueSize = null;
          let optCount = 0;
          let optionsEls = '<option value="" disabled selected>Select size</option>';
          sizeSelectEl && prod.variants.forEach(variant => {
            const option = variant.option2;
            if (option && (variant.inventory_policy == 'continue' || prod.tags.includes('inventory_threshold_ignore') || variant.inventory_quantity > this.settings.outOfStockThreshold)) {
              let selected = false;
              if (!isEmptyCart && this.settings.upsTrueSizeEnabled || isEmptyCart && this.settings.upsEmptyCartTrueSizeEnabled) {
                if (braSize && productType === 'bra' && option === braSize) {
                  selected = true;
                  addToCartButtonEl.disabled = false;
                  trueSize = variant.option2;
                } else if (underwearSize && (productType === 'panties' || productType === 'sleepwear') && option === underwearSize) {
                  selected = true;
                  addToCartButtonEl.disabled = false;
                  trueSize = variant.option2;
                } else if (mappedSize && option === mappedSize) {
                  selected = true;
                  addToCartButtonEl.disabled = false;
                  trueSize = variant.option2;
                } else if (mappedSizeAlpha && option === mappedSizeAlpha) {
                  selected = true;
                  addToCartButtonEl.disabled = false;
                  trueSize = variant.option2;
                }
              }
              optionsEls += `<option value="${option}" ${selected ? 'selected' : ''}>${option}</option>`;
              if (optCount === 0) {
                priceEl.textContent = toMoney(variant.price);
              }
              optCount++;
            }
          });

          sizeSelectEl.insertAdjacentHTML('beforeend', optionsEls);

          if (
            (!isEmptyCart && this.settings.upsTrueSizeEnabled && this.settings.upsOnlyTrueSizeEnabled && !this.settings.upsSizeSelectorEnabled && trueSize) ||
            (isEmptyCart && this.settings.upsEmptyCartTrueSizeEnabled && this.settings.upsEmptyCartOnlyTrueSizeEnabled && !this.settings.upsEmptyCartSizeSelectorEnabled && trueSize)
          ) {
            sizeSelectEl.classList.add('hidden');
            priceEl.innerHTML += ` - ${trueSize}`;
          }

          if (addToCartButtonEl && addToCartButtonEl.disabled && sizeSelectEl) {
            sizeSelectEl.addEventListener('change', () => {
              addToCartButtonEl.disabled = false;
            });
          }

          if (!optCount) {
            console.error(`Product not included in recommendation slider because it has no variant available: ${prod.title} (${prod.id})`);
            return;
          }

          if (optCount === 1 && prod.product_type?.toLowerCase() === 'kit' && sizeSelectEl && addToCartButtonEl) {
            sizeSelectEl.disabled = true;
            addToCartButtonEl.textContent = 'Go to bundle';
            addToCartButtonEl.addEventListener('click', async () => {
              location.href = url;
            });
          } else if (addToCartButtonEl) {
            addToCartButtonEl.addEventListener('click', async () => {
              window.broadcastChannel.dispatchEvent('disable-cart-upsells');
              const selectSize = sizeSelectEl.options[sizeSelectEl.selectedIndex]?.value;
              const variant = prod.variants.find(variant => variant.option2 === selectSize);

              if (!selectSize || !variant) {
                console.error('Error adding product to the cart');
                return;
              }

              const payload = {
                id: variant.id,
                quantity: 1,
                properties: {
                  _tags: filterProductTags(prod.tags)
                }
              };

              const price = variant.price;
              const compareAtPrice = variant.compare_at_price;
              if (window.Shopify.country === 'CA' && compareAtPrice && compareAtPrice > price) {
                payload.properties._compareAtPrice = Math.trunc((compareAtPrice / 100) / window.i18n_cad_exchange_rate) * 100;
                payload.properties._compareAtPriceCa = compareAtPrice;
              } else if (compareAtPrice && compareAtPrice > price) {
                payload.properties._compareAtPrice = compareAtPrice;
                payload.properties._compareAtPriceCa = Math.ceil((compareAtPrice / 100) * window.i18n_cad_exchange_rate) * 100;
              }

              if (window.cart_settings?.checkoutFinalSaleLabel && payload.properties._tags?.some(tag => tag.toLowerCase().replaceAll(/\s|-|_/g, '').includes('finalsale'))) {
                payload.properties['Final Sale'] = window.cart_settings.checkoutFinalSaleLabel;
              }

              await window.cartManager.addItem(payload);

              // Send GTM RECO data
              window.sendGTMData && window.sendGTMData({
                event: 'cart_recommendation_add_to_cart',
                source: 'cart-drawer',
                product_id: prod.id,
                product_name: prod.title,
                product_url: url,
                product_price: prod.price,
                product_size: variant.option2,
                product_color: variant.option1,
                quantity: 1
              });

              window.dispatchEvent(new CustomEvent('update-cart'));
            });
          }
        } else {
          sizeSelectEl.remove();
          addToCartButtonEl.remove();
        }

        // Append products into slider
        sliderEl.append(productRecommendation);
      });

      if (isEmptyCart) {
        this.style.justifyContent = 'space-between';
      } else {
        this.style.justifyContent = 'flex-start';
      }

      if (sliderEl.innerHTML) {
        const loyaltyBannerEl = document.querySelector('.js-loyalty-banner');
        const gwpBoxEl = this.querySelector('.js-component-cart-gwp-box');
        if (this.settings.upsPosition === 'top') {
          this.recContainerEl?.classList.add('position-top');
          if (loyaltyBannerEl && !loyaltyBannerEl.classList.contains('hidden') && isEmptyCart) {
            loyaltyBannerEl.after(this.recContainerEl);
          } else if (this.settings.gwpEnabled && gwpBoxEl && this.settings.gwpPosition === 'top') {
            gwpBoxEl?.before(this.recContainerEl);
          } else {
            this.itemsBlock.before(this.recContainerEl);
          }
        } else {
          this.recContainerEl?.classList.add('position-bottom');
          if (loyaltyBannerEl && !loyaltyBannerEl.classList.contains('hidden')) {
            loyaltyBannerEl.after(this.recContainerEl);
          } else if (this.settings.gwpEnabled && gwpBoxEl && this.settings.gwpPosition === 'bottom') {
            gwpBoxEl?.after(this.recContainerEl);
          } else {
            this.itemsBlock.after(this.recContainerEl);
          }
        }
      }
    }

    async renderUpsellsRebuy() {
      const visitorID = localStorage.getItem('rebuy_user_uuid');

      let queryParams = {
        key: this.settings.upsRebuyApiKey,
        limit: this.settings.upsRebuyApiLimit,
        filter_oos: 'yes',
        context: 'default',
      }

      if (this.settings.upsRebuyType === 'viewed') {
        const viewedParams = {
          subject: "user",
          verb: "viewed",
          noun: "product",
          uuid: visitorID
        }
        queryParams = { ...queryParams, ...viewedParams }
      }

      const response = await fetch(`${this.settings.upsRebuyProductsApiUrl}${this.settings.upsRebuyType}?${new URLSearchParams(queryParams).toString()}`, {
        method: "GET",
        headers: {
          'Content-Type': 'application/json'
        }
      });
      const resJson = await response.json();
      const rebuyProducts = resJson.data;
      const products = [];

      if (!rebuyProducts.length) return;

      for (let i = 0; i < rebuyProducts.length; i++) {
        const response = await fetch(`${window.Shopify.routes.root}products/${rebuyProducts[i].handle}.js`);
        if (response.ok) {
          const data = await response.json();
          products.push(data);
        } else {
          console.error(`Rebuy upsells - Error fetching product: ${rebuyProducts[i].handle}`);
        }
      }

      this.rebuyRecContainerEl?.remove();

      const cartItemsAmount = window.cartManager?.getLocalCart()?.items?.length || 0;
      const underwearSize = this.settings.trueSize?.underwearSize || null;
      const braSize = this.settings.trueSize?.braSize || null;

      this.rebuyRecContainerEl = this.querySelector('.js-template-recommendations')?.content?.cloneNode(true).querySelector('.js-ups');

      if (this.rebuyRecContainerEl) {

        this.rebuyRecContainerEl.classList.add('cart-rebuy-section');

        this.rebuyRecContainerEl.querySelector('.component-cart-body__ups__title').textContent = this.settings.upsRebuyTitle;

        if (products.length <= 3) this.rebuyRecContainerEl?.querySelector('.button-wrap')?.remove();

        const sliderEl = this.rebuyRecContainerEl?.querySelector('.js-ups-slider');

        if (sliderEl && sliderEl.childNodes.length) {
          sliderEl.innerHTML = '';
        }
      }

      products.forEach((prod, index) => {

        const productRecContainer = this.querySelector('.js-template-ups-product') ? this.querySelector('.js-template-ups-product').content?.cloneNode(true) : null;
        
        if (!productRecContainer) return;

        const imageLink = productRecContainer.querySelector('.js-recommendation-product-image-link');
        const url = `https://${window.Shopify.shop}${window.Shopify.routes.root}products/${prod.handle}`;
        imageLink.href = url;

        const imageEl = productRecContainer.querySelector('.js-recommendation-product-image');
        imageEl.alt = prod.image?.alt || prod.title;

        let src = prod.images[0].split('.jpg');
        const innerWidth = window.innerWidth;
        src = src[0] + (innerWidth < 768 ? '_190x.jpg' : '_240x.jpg') + src[1];
        const indexThreshold = window.innerWidth < 992 ? 3 : 2;
        if (cartItemsAmount > 5 || index > indexThreshold) {
          imageEl.dataset.src = src;
          imageEl.classList.add('lazyload');
        } else {
          imageEl.src = src;
        }

        const nameEl = productRecContainer.querySelector('.js-recommendation-product-title');
        nameEl.textContent = prod.title;
        nameEl.href = url;

        const priceEl = productRecContainer.querySelector('.js-recommendation-product-price');
        priceEl.textContent = toMoney(prod.variants[0].price);

        // Add add-to-cart button
        const sizeSelectEl = productRecContainer.querySelector('.js-recommendation-product-size-select');
        const addToCartButtonEl = productRecContainer.querySelector('.js-recommendation-product-add-to-cart-button');
        addToCartButtonEl.textContent = this.settings.upsRebuyButtonLabel;

        const productType = prod.type.toLowerCase();
        const isForm360 = prod.tags.includes('precise_sizing');
        const mappedSize = (braSize && isForm360) ? getMappedFormfitSize(braSize) : null;
        const mappedSizeAlpha = (braSize && productType !== 'bra' && prod.tags.includes('alpha')) ? getMappedAlphaSize(braSize) : null;
        let optCount = 0;
        let optionsEls = '<option value="" disabled selected>Select size</option>';
        sizeSelectEl && prod.variants.forEach(variant => {
          const option = variant.option2;
          if (!option) return;
          if (variant.inventory_policy === 'deny' && variant.inventory_quantity < 1) return;
          if (variant.inventory_policy === 'deny' && !prod.tags.includes('inventory_threshold_ignore') && variant.inventory_quantity <= this.settings.outOfStockThreshold) return;
          let selected = false;
          if (braSize && productType === 'bra' && option === braSize) {
            selected = true;
            addToCartButtonEl.disabled = false;
          } else if (underwearSize && productType === 'panties' && option === underwearSize) {
            selected = true;
            addToCartButtonEl.disabled = false;
          } else if (mappedSize && option === mappedSize) {
            selected = true;
            addToCartButtonEl.disabled = false;
          } else if (mappedSizeAlpha && option === mappedSizeAlpha) {
            selected = true;
            addToCartButtonEl.disabled = false;
          }
          optionsEls += `<option value="${option}" ${selected ? 'selected' : ''}>${option}</option>`;
          optCount++;
        });

        sizeSelectEl.insertAdjacentHTML('beforeend', optionsEls);

        if (addToCartButtonEl && addToCartButtonEl.disabled && sizeSelectEl) {
          sizeSelectEl.addEventListener('change', () => {
            addToCartButtonEl.disabled = false;
          });
        }

        if (!optCount) {
          console.error(`Product not included in recommendation slider because it has no variant available: ${prod.title} (${prod.id})`);
          return;
        }

        if (optCount === 1 && productType === 'kit' && sizeSelectEl && addToCartButtonEl) {
          sizeSelectEl.disabled = true;
          addToCartButtonEl.textContent = 'Go to bundle';
          addToCartButtonEl.addEventListener('click', async () => {
            location.href = url;
          });
        } else if (addToCartButtonEl) {
          addToCartButtonEl.addEventListener('click', async () => {
            window.broadcastChannel.dispatchEvent('disable-cart-upsells');
            const selectSize = sizeSelectEl.options[sizeSelectEl.selectedIndex]?.value;
            const variant = prod.variants.find(variant => variant.option2 === selectSize);

            if (!selectSize || !variant) {
              console.error('Error adding product to the cart');
              return;
            }

            const payload = {
              id: variant.id,
              quantity: 1,
              properties: {
                _tags: filterProductTags(prod.tags).map(tag => tag.trim()),
                _source: 'Rebuy',
                _attribution: 'Rebuy Cart Upsells'
              }
            };

            const price = variant.price;
            const compareAtPrice = variant.compare_at_price;
            if (window.Shopify.country === 'CA' && compareAtPrice && compareAtPrice > price) {
              payload.properties._compareAtPrice = Math.trunc((compareAtPrice / 100) / window.i18n_cad_exchange_rate) * 100;
              payload.properties._compareAtPriceCa = compareAtPrice;
            } else if (compareAtPrice && compareAtPrice > price) {
              payload.properties._compareAtPrice = compareAtPrice;
              payload.properties._compareAtPriceCa = Math.ceil((compareAtPrice / 100) * window.i18n_cad_exchange_rate) * 100;
            }

            if (window.cart_settings?.checkoutFinalSaleLabel && payload.properties._tags?.some(tag => tag.toLowerCase().replaceAll(/\s|-|_/g, '').includes('finalsale'))) {
              payload.properties['Final Sale'] = window.cart_settings.checkoutFinalSaleLabel;
            }

            await window.cartManager.addItem(payload);

            await this.notifyRebuyViewed(prod.handle);

            window.dispatchEvent(new CustomEvent('update-cart'));
          });
        }

        // Append products into slider
        sliderEl.append(productRecContainer);
      });
      if(this.querySelector('.component-cart-body-text-block') && this.rebuyRecContainerEl) {
        this.querySelector('.component-cart-body-text-block').before(this.rebuyRecContainerEl);
      }
    }

    async notifyRebuyViewed(productHandle) {
      try {
        const visitorID = localStorage.getItem('rebuy_user_uuid') || crypto.randomUUID();
        localStorage.setItem('rebuy_user_uuid', visitorID);

        const queryParams = {
          "key": this.settings.upsRebuyApiKey,
          "subject": "user",
          "verb": "added",
          "noun": "product",
          "uuid": visitorID,
          "shopify_product_handle": productHandle
        }
        await fetch(`${this.settings.upsRebuyEventApiUrl}?${new URLSearchParams(queryParams).toString()}`,
          {
            method: 'POST'
          }
        );
      } catch (error) {
        console.error('Error sending view event to Rebuy', error);
      }
    }

    renderPerfectFit() {
      const perfectPromise = document.querySelector('.js-component-cart-body-text-block-description');
      const perfectPromiseActionBtn = perfectPromise.querySelector('.js-text-toggle');

      perfectPromiseActionBtn.addEventListener('click', (e) => {
        const expanded = perfectPromise.dataset.expanded === 'true';
        let content = this.perfectPromiseContent;
        if (!expanded) {
          content = `${this.perfectPromiseContent.substring(0, 150)}...`;
        }
        expanded ? e.target.innerText = 'Read less' : e.target.innerText = 'Read more';
        perfectPromise.querySelector('p').innerText = content;
        perfectPromise.dataset.expanded = (!expanded).toString();
      });

      perfectPromiseActionBtn.click();
    }
  });
}
